import type { Kk7BoundaryAuditTrack } from './kk7-boundary-audit-model.js';

// Generated from the full-corpus KK7 boundary-impact evaluation.
export const KK7_BOUNDARY_AUDIT_TRACKS: readonly Kk7BoundaryAuditTrack[] = [
  {
    id: '2dd8269e-4347-4869-a4b8-cea716cfb96b',
    title: 'Club Aurora',
    cohort: 'removed',
    rank: 1,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_629126b2-6f1d-4193-ac10-d4da3b2c8d01_1.ogg',
    impactScore: 0.9380288245576722,
  },
  {
    id: '32e7d833-3b40-4bea-bc1e-1cf7f58a77a4',
    title: 'Low Tide Voltage',
    cohort: 'removed',
    rank: 2,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_738d99ea-3604-435f-8077-17e1bafb5241_0.ogg',
    impactScore: 0.9362739744444363,
  },
  {
    id: 'db913064-3c2d-4feb-bab4-1f09fdb5b065',
    title: 'Club Surge',
    cohort: 'removed',
    rank: 3,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_99c28e0a-2623-4f99-bb3d-626b087af8bd_1.ogg',
    impactScore: 0.9344188384234827,
  },
  {
    id: 'a0bd32a3-98d5-4a83-bac1-73fc02cba0ee',
    title: 'Club Mirage',
    cohort: 'removed',
    rank: 4,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_89a3f41e-78fc-4229-a757-9a7a729be61c_1.ogg',
    impactScore: 0.9333922111066764,
  },
  {
    id: '7536ca19-1e84-40ad-a902-842d6944bf73',
    title: 'Club Surge',
    cohort: 'removed',
    rank: 5,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f4428e45-f13d-4735-a419-7fe64984a270_0.ogg',
    impactScore: 0.9270888288081651,
  },
  {
    id: '0bd41016-5f0d-4763-820b-ceaaa543de46',
    title: 'Electric Runway',
    cohort: 'removed',
    rank: 6,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4d4f8940-2c90-4d13-9cbc-e19850756b0a_1.ogg',
    impactScore: 0.9266273678468514,
  },
  {
    id: '7dfa223f-7072-41ad-a49d-19e8cb662d0e',
    title: 'Midnight Hex Drive',
    cohort: 'removed',
    rank: 7,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b306d418-8fef-4e99-a5f4-1e29854684f3_1.ogg',
    impactScore: 0.9263035181984909,
  },
  {
    id: 'f2621200-2813-43a3-bf59-2f95108f065c',
    title: 'Warehouse Pulse',
    cohort: 'removed',
    rank: 8,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8b319517-b84f-4c5d-85ac-05ca2b1b0238_0.ogg',
    impactScore: 0.9262420013130807,
  },
  {
    id: 'e8a27035-695d-4b95-a186-69ded70ebffc',
    title: 'Pulse Surge',
    cohort: 'removed',
    rank: 9,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d7902424-ee0b-448d-b865-18319df666de_0.ogg',
    impactScore: 0.9257856840998439,
  },
  {
    id: 'a1ed6b61-fa5c-491f-a41a-07bbb53c98e3',
    title: 'Jersey Stars',
    cohort: 'removed',
    rank: 10,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_81002fed-aedb-4277-bbc2-18105417d0e7_1.ogg',
    impactScore: 0.9188371323909671,
  },
  {
    id: 'c8f8583a-c3dc-4e11-91be-2ff435dc341d',
    title: 'Hexd in the Club',
    cohort: 'removed',
    rank: 11,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b048f414-ad94-4a14-827d-ecc2d90206a3_0.ogg',
    impactScore: 0.9157636542857028,
  },
  {
    id: 'ab272c58-9703-4194-9c13-5582534433a4',
    title: 'Velocity Dreams',
    cohort: 'removed',
    rank: 12,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_23226efa-06aa-4f19-8874-50aedaf34b8b_1.ogg',
    impactScore: 0.9154654962091865,
  },
  {
    id: '45f6437f-6fd9-4a85-8764-d9f5ccb90c70',
    title: 'Accelerated Hearts',
    cohort: 'removed',
    rank: 13,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ae018a72-882c-445d-932a-831ce2738f01_0.ogg',
    impactScore: 0.9149943875140877,
  },
  {
    id: 'ad858ab4-6840-4de5-9911-e9770bef5b96',
    title: 'Underground Pulse',
    cohort: 'removed',
    rank: 14,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6dd893a2-5fc2-4d93-9065-53d191202332_1.ogg',
    impactScore: 0.9146021683400031,
  },
  {
    id: '97a69c94-3eaf-4dfe-9bc6-1ff2ccc271db',
    title: 'Hexed Lights',
    cohort: 'removed',
    rank: 15,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_57960387-0126-44f5-a707-2961f114d0c9_1.ogg',
    impactScore: 0.9141552706425714,
  },
  {
    id: '9f181150-91e8-4370-b3e8-ba4cc3dd3226',
    title: 'Club Static',
    cohort: 'removed',
    rank: 16,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fc3e055e-4220-440c-b05c-85f8f3469899_0.ogg',
    impactScore: 0.9131143323806747,
  },
  {
    id: '92857eaa-db36-4bed-b602-42c44637c3bb',
    title: 'Jersey Nights',
    cohort: 'removed',
    rank: 17,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3f052c5b-637b-490c-a69b-432d128eb6da_0.ogg',
    impactScore: 0.9123595915292967,
  },
  {
    id: 'fea263fe-f5ac-4e7e-a617-6939514b925e',
    title: 'Hexd Hearts on the Club Floor',
    cohort: 'removed',
    rank: 18,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_271ac84b-dd95-4a78-94c0-cf49555e20cb_0.ogg',
    impactScore: 0.9106342268331076,
  },
  {
    id: '080fff7a-4ad4-4191-914c-02ba0c1d7805',
    title: 'Hexed Pulse',
    cohort: 'removed',
    rank: 19,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f872d92f-8f70-4711-80db-3f19a70ad43e_1.ogg',
    impactScore: 0.9096963138837498,
  },
  {
    id: 'edd61e4a-bf23-4a50-a493-a4f78483d6c6',
    title: 'Hexd Pulse Line',
    cohort: 'removed',
    rank: 20,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fd705d09-161b-4fdf-a3db-dfd108d0db9e_1.ogg',
    impactScore: 0.9084730095599703,
  },
  {
    id: '7c5e1aad-ce51-4088-ac2b-8e4a923206eb',
    title: 'Bassline Horizon',
    cohort: 'removed',
    rank: 21,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2dacd01c-aa2b-47c8-8ecf-9daf2b76315d_1.ogg',
    impactScore: 0.9075674813533736,
  },
  {
    id: '6489f0de-f6b9-44df-8339-b38c1ebc3d7b',
    title: 'Bassline Horizon',
    cohort: 'removed',
    rank: 22,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_57960387-0126-44f5-a707-2961f114d0c9_0.ogg',
    impactScore: 0.9066318050238891,
  },
  {
    id: '58a96bd5-cadc-442d-a5a2-3fd4b43c68ab',
    title: 'Velocity Sky',
    cohort: 'removed',
    rank: 23,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0ced9624-021c-4435-b0b7-f8649febc3db_1.ogg',
    impactScore: 0.8986583807741463,
  },
  {
    id: 'ca62e8b7-1502-4b3d-84ed-9e03453c758c',
    title: 'Hexd Heartbeats',
    cohort: 'removed',
    rank: 24,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f1555a2b-b086-40d4-88f5-ad36b87029bc_0.ogg',
    impactScore: 0.8974318373247518,
  },
  {
    id: '899a86af-6219-4274-afb9-22ccccdedfd0',
    title: 'Velocity Bloom',
    cohort: 'removed',
    rank: 25,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9ad06be0-b62f-443f-b6d8-1ede4aac1de3_1.ogg',
    impactScore: 0.8954980197068889,
  },
  {
    id: 'c15c0eb2-d2dc-45ae-ae31-a78c6a5fa8bd',
    title: 'Hexed Pulse',
    cohort: 'removed',
    rank: 26,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_99ac7d18-1e06-414f-bcd0-c1ef468ca7fb_0.ogg',
    impactScore: 0.8941522689817143,
  },
  {
    id: '7c151537-8ae7-422a-8a2f-3d36e524cb72',
    title: 'Runaway Signal',
    cohort: 'removed',
    rank: 27,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e491dd4d-6a2f-47ba-98b1-a19d8979e6fe_0.ogg',
    impactScore: 0.8898527401633516,
  },
  {
    id: '00c78b78-c2a3-4681-adb5-c38f8b6a8095',
    title: 'Clubverdrive',
    cohort: 'removed',
    rank: 28,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_20347ec1-f24c-4268-9f18-ba4c9140296c_1.ogg',
    impactScore: 0.8893497325884235,
  },
  {
    id: 'ef42d172-0dbd-4bab-b2ed-ea98a367fd50',
    title: 'Static Hearts in Motion',
    cohort: 'removed',
    rank: 29,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3027c235-1bbe-431b-8edb-569471925923_0.ogg',
    impactScore: 0.8880687938000066,
  },
  {
    id: 'cf525583-ef2f-4bd3-bdda-590e5c6f9c91',
    title: 'Sixteen Bars of Heaven',
    cohort: 'removed',
    rank: 30,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_dc7d7373-c985-4328-ac07-42674ecb3b87_0.ogg',
    impactScore: 0.8830646197246248,
  },
  {
    id: 'ba5d071d-9f12-4d3b-a9f1-3d54ce1e50fd',
    title: 'Electric Overdrive',
    cohort: 'removed',
    rank: 31,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ff78bada-0ff4-4b4a-bd98-c330a78fa16d_1.ogg',
    impactScore: 0.8812961061350587,
  },
  {
    id: '85de677f-18f2-429a-9f97-7b7ea644768e',
    title: 'Club Horizon',
    cohort: 'removed',
    rank: 32,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b2e30690-cdbf-4a27-bff5-39c2d478d278_0.ogg',
    impactScore: 0.8786202590671781,
  },
  {
    id: '069cfdfd-70bd-487a-9c81-2482c0ed1c99',
    title: 'Jersey Pulse',
    cohort: 'removed',
    rank: 33,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_43cad99e-82ae-4012-8e19-cc66e5419d75_0.ogg',
    impactScore: 0.8760593283335497,
  },
  {
    id: '2336526c-4de0-4788-9d77-cd474147f7a6',
    title: 'Glitch in the Rush',
    cohort: 'removed',
    rank: 34,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_12c57656-1182-41f5-a16f-f607895964e1_1.ogg',
    impactScore: 0.8757648330643156,
  },
  {
    id: '57d66962-139b-495b-a5bb-ab03e719f21b',
    title: 'Sixth Gear',
    cohort: 'removed',
    rank: 35,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f715c17b-f82f-4eba-a33e-3d93e8d520d6_1.ogg',
    impactScore: 0.8754101828643761,
  },
  {
    id: 'af45d2e8-eb9e-4c46-be21-d48bcb89bd59',
    title: 'Bounce the Hex',
    cohort: 'removed',
    rank: 36,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_89cd214c-7761-4b7c-a9b3-77543bb967ba_0.ogg',
    impactScore: 0.8699928338148619,
  },
  {
    id: '53ae150f-cf3b-4808-9780-096a7397be9a',
    title: 'Berlin Bounce',
    cohort: 'removed',
    rank: 37,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_caa4d588-536e-4237-ad6c-32aa773c1092_1.ogg',
    impactScore: 0.8616468163671216,
  },
  {
    id: 'c3fc11eb-e7bf-4927-b13b-6d734dfdd76f',
    title: 'Velocity Hex',
    cohort: 'removed',
    rank: 38,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_98521df9-99dd-4900-8c9b-5bd79dd92170_0.ogg',
    impactScore: 0.859639094800108,
  },
  {
    id: 'b2b47a47-301e-4fce-a53b-566a8712c4a8',
    title: 'Glitch in the Heart Rate',
    cohort: 'removed',
    rank: 39,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4d5e7933-9e42-4151-9af0-f0684a312cde_0.ogg',
    impactScore: 0.8595926079206486,
  },
  {
    id: '81ceca96-fcca-4ce7-8eca-df3bedcb77ef',
    title: 'Crowd Surge Protocol',
    cohort: 'removed',
    rank: 40,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ef180064-9a3c-40f1-8126-8c9a1222c3f1_1.ogg',
    impactScore: 0.8580709759609139,
  },
  {
    id: '2d6ed7ec-35fd-433a-91fe-2bb3f08a8de9',
    title: 'Electric Heartbeat',
    cohort: 'removed',
    rank: 41,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_70a3c88e-8bcf-4a9f-94d8-b7a108fa1c05_0.ogg',
    impactScore: 0.8579718508978086,
  },
  {
    id: 'f58874d5-4b0e-44fb-9c0f-fdf55ada918e',
    title: 'Club Voltage Hearts',
    cohort: 'removed',
    rank: 42,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fd705d09-161b-4fdf-a3db-dfd108d0db9e_0.ogg',
    impactScore: 0.8565358775888152,
  },
  {
    id: 'cc44391e-439c-4a65-9547-bdbfb1dc8c52',
    title: 'Pulse Circuit',
    cohort: 'retained',
    rank: 43,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6490d8c1-c7a4-481a-9c7a-10a33a81a043_0.ogg',
    impactScore: 0.8562864603088549,
  },
  {
    id: '1ab0869b-8744-4eed-bd38-c3b3dbb8f311',
    title: 'Hexagon Rush',
    cohort: 'removed',
    rank: 44,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_40b3f258-4959-44b5-a245-17eeade9d9e9_1.ogg',
    impactScore: 0.856117978266446,
  },
  {
    id: '39a2925f-f0fe-4c08-8179-b89144af9f40',
    title: 'Hexed Horizons',
    cohort: 'removed',
    rank: 45,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4094b4e1-d0a8-462b-8abd-9782ea53e816_1.ogg',
    impactScore: 0.8542358196295928,
  },
  {
    id: 'c9cb277b-4895-4633-bf51-272e0aab3e55',
    title: 'Club Static Pulse',
    cohort: 'removed',
    rank: 46,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a5b3a3f0-e03e-48e8-90c9-381eb9efc740_1.ogg',
    impactScore: 0.8541535930652426,
  },
  {
    id: '15cc875b-6c7b-4130-b873-d797b5736275',
    title: 'Club Horizon',
    cohort: 'removed',
    rank: 47,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_89cd214c-7761-4b7c-a9b3-77543bb967ba_1.ogg',
    impactScore: 0.8507803655439428,
  },
  {
    id: 'd59dc537-3e80-4ee4-8cd1-156a656fd42c',
    title: 'Club Static Pulse',
    cohort: 'removed',
    rank: 48,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b2f3d3ca-4961-47be-acab-d070cd783d75_1.ogg',
    impactScore: 0.8492479377933576,
  },
  {
    id: 'd30e74f6-2f63-470f-acac-49046d8054b6',
    title: 'Hex Horizon',
    cohort: 'removed',
    rank: 49,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0f7321f8-73d2-4dbc-b630-5f1dba7ba690_1.ogg',
    impactScore: 0.846528790993968,
  },
  {
    id: 'eb45d180-3e72-4e56-b4ee-5137e73461a5',
    title: 'Turbo Trance',
    cohort: 'removed',
    rank: 50,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_85e0506c-f230-465e-80c6-2f8bd36aea80_1.ogg',
    impactScore: 0.8432392076320243,
  },
  {
    id: 'd275ac30-c064-4584-bf7d-8302903e76e7',
    title: 'Glitch in the Afterglow',
    cohort: 'retained',
    rank: 51,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b81f985a-a33a-4ba2-b25d-8cdcafa46a76_1.ogg',
    impactScore: 0.8417623221628574,
  },
  {
    id: '7a9be7b8-cdb5-482a-a798-d0652a643d2e',
    title: 'Electric Jersey Pulse',
    cohort: 'removed',
    rank: 52,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_1566c765-fd76-4ddd-baed-11b15144da82_1.ogg',
    impactScore: 0.839103793853748,
  },
  {
    id: 'd05719a8-11e0-47a9-ad35-acad56437f10',
    title: 'Neon Circuits',
    cohort: 'removed',
    rank: 53,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_85e0506c-f230-465e-80c6-2f8bd36aea80_0.ogg',
    impactScore: 0.8389162052201353,
  },
  {
    id: '0a3e480b-b882-487d-83a8-5a2c7915e2b0',
    title: 'Club Voltage',
    cohort: 'removed',
    rank: 54,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_35221472-8757-40ed-9307-a584fff09c91_1.ogg',
    impactScore: 0.8379245411327486,
  },
  {
    id: 'f19c1103-d27d-42a0-b20a-7d6d5fe9f96c',
    title: 'Club of the Damned',
    cohort: 'removed',
    rank: 55,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_db83afc4-070b-4b97-a36e-b28122d277b9_0.ogg',
    impactScore: 0.8369382197407549,
  },
  {
    id: '69459e26-3be6-4359-9c1a-02f67511b4e4',
    title: 'Shattered Frequencies',
    cohort: 'removed',
    rank: 56,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_07deeaec-7a1e-4423-94a4-effbca0e3da4_1.ogg',
    impactScore: 0.8338613294453402,
  },
  {
    id: '8be439d9-47bf-4cc7-9c42-7b6645df1e96',
    title: 'Sixteen Frames of Starlight',
    cohort: 'removed',
    rank: 57,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8b28effd-6d47-4595-a3af-7ee1f51b0a8a_0.ogg',
    impactScore: 0.8306500221348817,
  },
  {
    id: '31cc86d7-cbc7-4dc1-9531-653bde7714c4',
    title: 'Hexed Velocity',
    cohort: 'removed',
    rank: 58,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4ef61b9c-0fbf-4de2-820c-460d52194601_1.ogg',
    impactScore: 0.8278448347580919,
  },
  {
    id: '69a84ac8-9ddf-4310-8e89-f28d9fe620bc',
    title: 'Static Hearts',
    cohort: 'removed',
    rank: 59,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_bf057188-3408-44bd-8c66-69c71f569598_1.ogg',
    impactScore: 0.8278231161114012,
  },
  {
    id: 'cf5e18ac-9daf-427e-a501-3fad032b1008',
    title: 'Hexd Pulse',
    cohort: 'removed',
    rank: 60,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8b478791-65da-48a3-9a6c-f60fb0214290_1.ogg',
    impactScore: 0.8271110610668075,
  },
  {
    id: '085827a7-62f6-4ca6-b9c7-8c710838ba8a',
    title: 'Lost in the Frequency',
    cohort: 'retained',
    rank: 61,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a8dc3095-7482-4359-a5cc-493eafbfb001_1.ogg',
    impactScore: 0.8266323196369972,
  },
  {
    id: 'b3618747-9cc6-4882-8fc6-747747a3c58f',
    title: 'Jersey Skyline',
    cohort: 'removed',
    rank: 62,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b048f414-ad94-4a14-827d-ecc2d90206a3_1.ogg',
    impactScore: 0.826186732828881,
  },
  {
    id: '63926770-7ce4-455e-9d33-f4fdb253f1c6',
    title: 'Pulse Circuit',
    cohort: 'removed',
    rank: 63,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4c95a815-8dd8-4b71-ab6d-bc6bb710942f_0.ogg',
    impactScore: 0.824557835347116,
  },
  {
    id: 'c029fb43-32f1-4f9a-b6d5-7e601da62944',
    title: 'Club Static',
    cohort: 'removed',
    rank: 64,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e6ad80d5-2ade-403e-ad19-61e74f907063_1.ogg',
    impactScore: 0.8203312244780613,
  },
  {
    id: '3ae7afd0-4b34-47dd-b029-05dd01c1b972',
    title: 'Club Static',
    cohort: 'removed',
    rank: 65,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_11c922b6-7ea1-4d5e-a77a-eda3da24c0c3_0.ogg',
    impactScore: 0.8165287060842312,
  },
  {
    id: 'e2ab627d-77d8-4682-a89f-8924e12f129b',
    title: 'Ghost Frequency',
    cohort: 'removed',
    rank: 66,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_20347ec1-f24c-4268-9f18-ba4c9140296c_0.ogg',
    impactScore: 0.8165166517969361,
  },
  {
    id: '3224d0a3-cebc-4a6f-8738-d65e7d30b490',
    title: 'Velocity Skyline',
    cohort: 'removed',
    rank: 67,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_01dc8246-acb6-46bc-bacf-126b99f80686_0.ogg',
    impactScore: 0.8160187250375538,
  },
  {
    id: '8e6889ac-ccc2-4a65-8e9e-0af4ce182450',
    title: 'Hexd Velocity',
    cohort: 'removed',
    rank: 68,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_79cbddcb-cae9-41ec-8ed6-1ae4d6b2e6cf_1.ogg',
    impactScore: 0.8118855154317377,
  },
  {
    id: 'b79da7af-6d3e-4dc6-837b-b4d612d7af34',
    title: 'Velocity Hearts',
    cohort: 'removed',
    rank: 69,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b306d418-8fef-4e99-a5f4-1e29854684f3_0.ogg',
    impactScore: 0.8104004302030758,
  },
  {
    id: '13157627-c92c-49ab-be09-71d901da7fef',
    title: 'Pulse of the Night',
    cohort: 'removed',
    rank: 70,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c33f8183-3a1e-4529-893e-d89a82344293_1.ogg',
    impactScore: 0.8093235264215469,
  },
  {
    id: '42f93a64-51f4-4e73-8e94-b426e3072075',
    title: 'Velocity Bloom',
    cohort: 'removed',
    rank: 71,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e0648960-0bd2-488a-8d38-c10fa71fe58b_1.ogg',
    impactScore: 0.808911747918591,
  },
  {
    id: 'cdeebedd-fa4e-412f-a035-f577532ba78b',
    title: 'Neon Overdrive',
    cohort: 'removed',
    rank: 72,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_40b3f258-4959-44b5-a245-17eeade9d9e9_0.ogg',
    impactScore: 0.802461659555352,
  },
  {
    id: '30682554-65e7-4e7f-ba42-633f9c64df0d',
    title: 'Run It Sideways',
    cohort: 'removed',
    rank: 73,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_25ce63ab-b382-4457-9fe3-1fb564fd6853_0.ogg',
    impactScore: 0.8002272552488772,
  },
  {
    id: '60ea3b06-04ea-44d0-bb73-f90543a4d23d',
    title: 'Hexagon Hearts',
    cohort: 'removed',
    rank: 74,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0ced9624-021c-4435-b0b7-f8649febc3db_0.ogg',
    impactScore: 0.7960821354696027,
  },
  {
    id: '248b0d41-d287-49c4-94ca-40449149f15b',
    title: 'Hexd Horizon',
    cohort: 'removed',
    rank: 75,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ae46d949-a2f0-4636-9a4b-fe9d19e47a72_1.ogg',
    impactScore: 0.7935171423875613,
  },
  {
    id: 'e47fb2ec-4404-4997-8208-c39d0810ddc0',
    title: 'Hexd Velocity',
    cohort: 'removed',
    rank: 76,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6e677df0-003b-4139-8e48-c90166970e8d_1.ogg',
    impactScore: 0.7914943651165762,
  },
  {
    id: '97100d3d-82d5-4e67-8232-1b24ecbd2cde',
    title: 'Hexed Frequency',
    cohort: 'removed',
    rank: 77,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a68051eb-d3b7-40ce-997d-66ec6d6ad58f_1.ogg',
    impactScore: 0.7913488021602378,
  },
  {
    id: '6e859731-861e-4da6-97e0-36d09c134c0f',
    title: 'Hexed Rush Hour',
    cohort: 'removed',
    rank: 78,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_51581ac2-1cca-4f9e-b7f2-c3f123df1d3b_0.ogg',
    impactScore: 0.7906016909441996,
  },
  {
    id: '1edd09fe-e23c-4a2e-9fd1-7fd9b67db204',
    title: 'Transatlantic Pulse',
    cohort: 'removed',
    rank: 79,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a8dc3095-7482-4359-a5cc-493eafbfb001_0.ogg',
    impactScore: 0.7866859588074965,
  },
  {
    id: '0c505378-21cd-432a-937c-be46dbe70e7d',
    title: 'Hexd Velocity Lane',
    cohort: 'removed',
    rank: 80,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ac5702a0-e023-424f-8344-af26a2b581ae_1.ogg',
    impactScore: 0.7851404520594362,
  },
  {
    id: 'f8210caa-4d78-4212-bd06-6a051fa56afb',
    title: 'Bassline Horizon',
    cohort: 'removed',
    rank: 81,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e70c64f4-c93d-4596-bcf7-a03a235f4853_1.ogg',
    impactScore: 0.7823215263851941,
  },
  {
    id: '60d34f48-2137-4c04-84da-66b24b5db734',
    title: 'Club Static',
    cohort: 'removed',
    rank: 82,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_83ae7920-8362-48c9-a3d2-f5607690e18c_0.ogg',
    impactScore: 0.7812423730794725,
  },
  {
    id: '032eafd5-9b13-4d2f-96c3-74855dd2c459',
    title: 'Static Bloom',
    cohort: 'removed',
    rank: 83,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_738d99ea-3604-435f-8077-17e1bafb5241_1.ogg',
    impactScore: 0.7768014744752118,
  },
  {
    id: 'b7febf6a-aa75-44a0-a4d6-0ed95111be7c',
    title: 'Pulse of the Night',
    cohort: 'removed',
    rank: 84,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fc3e055e-4220-440c-b05c-85f8f3469899_1.ogg',
    impactScore: 0.776126548571444,
  },
  {
    id: 'fb68bb5a-faab-44cd-8910-09338e537087',
    title: 'Midnight Pulse Protocol',
    cohort: 'removed',
    rank: 85,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_edb1c447-d803-4458-935f-1bec402cd4fd_0.ogg',
    impactScore: 0.7750803128310977,
  },
  {
    id: '064adde6-e0d5-4955-8e35-5ed9ef146480',
    title: 'Hexed Hearts on Speed',
    cohort: 'removed',
    rank: 86,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f402d064-16b0-4a11-b613-94052fcef533_1.ogg',
    impactScore: 0.7738808386159907,
  },
  {
    id: 'cbb4a5fd-9762-45be-911e-6fcca7fea24b',
    title: 'Club Circuit',
    cohort: 'removed',
    rank: 87,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7116cb47-e126-4fac-9fdd-f7f5cd371881_1.ogg',
    impactScore: 0.7665931613175401,
  },
  {
    id: 'c122ff82-ee9e-4aa1-ac50-2a3e435e80d5',
    title: 'Hyperdrive Hearts',
    cohort: 'removed',
    rank: 88,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b1cddc4d-4229-4f4c-8951-2ca3bccf9a48_0.ogg',
    impactScore: 0.757033282937216,
  },
  {
    id: 'fa98a5c4-f912-453e-99fd-d342b6ac9e4a',
    title: 'Circuit Dreams',
    cohort: 'removed',
    rank: 89,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e0648960-0bd2-488a-8d38-c10fa71fe58b_0.ogg',
    impactScore: 0.7515314059163659,
  },
  {
    id: 'b493dd35-dc03-4fe9-ada6-912a2424489a',
    title: 'High Voltage Dreams',
    cohort: 'removed',
    rank: 90,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_13d4b94c-6dc0-42ef-bc38-aa71d98e3081_1.ogg',
    impactScore: 0.7501487435667704,
  },
  {
    id: '6a2584c8-ac12-4b76-96ad-4891b5f53ef1',
    title: 'Neon Rush',
    cohort: 'removed',
    rank: 91,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_13d4b94c-6dc0-42ef-bc38-aa71d98e3081_0.ogg',
    impactScore: 0.7486127069471347,
  },
  {
    id: 'e60656d3-9a8b-4d51-aabf-ea87ab613ba4',
    title: 'Hexed Tempo',
    cohort: 'removed',
    rank: 92,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_caa4d588-536e-4237-ad6c-32aa773c1092_0.ogg',
    impactScore: 0.7475377091380642,
  },
  {
    id: '4394bb02-837c-4dd7-9bdc-eea6c97dfb05',
    title: 'Midnight Circuit Breaker',
    cohort: 'removed',
    rank: 93,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9b254f2e-6cef-4338-8e48-0faaa664d85f_0.ogg',
    impactScore: 0.7471805764199556,
  },
  {
    id: 'ac4a4381-5a84-4c77-8ae0-4746c9d8c611',
    title: 'Club Tonight',
    cohort: 'removed',
    rank: 94,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f215dbf4-c153-46cc-8003-a5662ca43666_0.ogg',
    impactScore: 0.7436472978355799,
  },
  {
    id: '2cd456ba-9c3a-4344-9bf3-c61bce60c3fd',
    title: 'Club Horizon',
    cohort: 'removed',
    rank: 95,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_327a47c5-6f59-436c-92e3-74579001bd62_0.ogg',
    impactScore: 0.7399650778421841,
  },
  {
    id: '65f6dfa6-e15d-4de1-8c74-4c4d540381df',
    title: 'Hexed Velocity',
    cohort: 'removed',
    rank: 96,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b9a1f683-d29a-4615-a5ec-694a0d1866cd_0.ogg',
    impactScore: 0.7392430821086982,
  },
  {
    id: 'bfaba0dc-79c4-4c88-84a4-0766ad01399f',
    title: 'Hexed Velocity',
    cohort: 'removed',
    rank: 97,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_38d26e1c-799f-4132-a19c-cb8e2cd17bba_1.ogg',
    impactScore: 0.7354337090905003,
  },
  {
    id: '8ef61255-56ff-41ef-a029-bb8c5fc75354',
    title: 'Dash Pulse Overdrive',
    cohort: 'removed',
    rank: 98,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ed3f4f05-8439-4613-825f-1655f3dde628_1.ogg',
    impactScore: 0.732498075885142,
  },
  {
    id: '5825dbb7-9c5b-40f5-b456-d7129dc7e3cc',
    title: 'Club Hexed',
    cohort: 'retained',
    rank: 99,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f9a71830-42f2-438a-b45d-e37c6532ff20_0.ogg',
    impactScore: 0.7322793873366756,
  },
  {
    id: '437238ba-0ec6-4676-9ee9-73a8bacb1c93',
    title: 'Club Voltage',
    cohort: 'removed',
    rank: 100,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a58df7b9-1d9d-4d59-94aa-d148c3334154_0.ogg',
    impactScore: 0.7264643182069935,
  },
  {
    id: 'd110e73c-df72-4666-8d9a-36184cd573c2',
    title: 'Club Of The Damned',
    cohort: 'removed',
    rank: 101,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_454996f4-d809-4303-a179-54eed8564de5_1.ogg',
    impactScore: 0.7243980446982565,
  },
  {
    id: 'bb663b45-2966-4e95-9a23-76c9963c105c',
    title: 'Hexed Horizons',
    cohort: 'removed',
    rank: 102,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3bc9a657-c08b-4cc5-a4ac-0d9dcf0ee8c3_1.ogg',
    impactScore: 0.7240516107692375,
  },
  {
    id: 'a4a8fc0b-89c7-4f09-80ea-62d782b4b2c3',
    title: 'Neon Jersey Rush',
    cohort: 'removed',
    rank: 103,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_335d341a-e5d4-496d-acf4-f23a4fb9aeeb_0.ogg',
    impactScore: 0.7205267498091261,
  },
  {
    id: '874ff3d3-8fe4-45b2-bab4-a681c15b8f7c',
    title: 'Neon Echo Chamber',
    cohort: 'retained',
    rank: 104,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e90581a7-d174-4872-9657-d9404a90e699_0.ogg',
    impactScore: 0.7154410007228231,
  },
  {
    id: '211bf7c4-e982-4050-bfe9-96a90b513709',
    title: 'Hyperdrive Heartbeat',
    cohort: 'removed',
    rank: 105,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_390bfc81-8bb5-4926-ae3b-f3afef86a201_1.ogg',
    impactScore: 0.7136489366588351,
  },
  {
    id: '2d494958-5c06-43ec-a961-06ddffacc258',
    title: 'Six Feet of Hex',
    cohort: 'retained',
    rank: 106,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a870ea9d-ca8e-447f-b651-e690f737e3d2_0.ogg',
    impactScore: 0.7116812710805591,
  },
  {
    id: 'bcef6f4b-486a-494f-ae8b-a24195351b01',
    title: 'Echoes in the Drop',
    cohort: 'removed',
    rank: 107,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8a438516-3f3b-4298-84ca-ccda5bd055cf_0.ogg',
    impactScore: 0.7112271398458112,
  },
  {
    id: '24b3fbfe-6e81-483b-bd6e-60875717752c',
    title: 'Hexd Kingdom',
    cohort: 'removed',
    rank: 108,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2dacd01c-aa2b-47c8-8ecf-9daf2b76315d_0.ogg',
    impactScore: 0.7080152137266577,
  },
  {
    id: 'cf00ef90-90f9-4770-8ad0-52956a7ecac9',
    title: 'Club Midnight Drive',
    cohort: 'removed',
    rank: 109,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3b30128d-e41e-45e9-a3cf-cc288492e1fe_1.ogg',
    impactScore: 0.7061928770917427,
  },
  {
    id: 'bd25b7f5-edb8-430f-8964-4e259722000d',
    title: 'Euro Trance Nova',
    cohort: 'removed',
    rank: 110,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7bd11f25-69aa-4b99-8d70-abdd9240f43d_0.ogg',
    impactScore: 0.705887345624715,
  },
  {
    id: '4052cb8d-bc16-4c99-9731-d64de2eab496',
    title: 'Circuit Breaker',
    cohort: 'removed',
    rank: 111,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4e61a077-3ed1-4a88-a8b1-d79fe98f2a61_0.ogg',
    impactScore: 0.7045244546896411,
  },
  {
    id: '72630573-0453-4f45-a23d-4df81da7aa30',
    title: 'Jersey Static',
    cohort: 'removed',
    rank: 112,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e7dfd75b-8e87-4282-b55d-7ad9911dd6fc_0.ogg',
    impactScore: 0.7003565707484828,
  },
  {
    id: '9ce3c210-7aed-47fd-9fb5-edb994f8fa47',
    title: 'Midnight Velocity',
    cohort: 'retained',
    rank: 113,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8e190b79-fbef-4a3f-929c-9956e62362fd_0.ogg',
    impactScore: 0.6963909987534834,
  },
  {
    id: '2795b680-8d15-4ca4-885a-b57977d97616',
    title: 'Hexdrive Pulse',
    cohort: 'retained',
    rank: 114,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4be21b18-920b-4364-a88f-9b647792b5cc_0.ogg',
    impactScore: 0.695175983602049,
  },
  {
    id: 'b897be96-f5e2-4b23-9440-2b5ccbae3b27',
    title: 'Glitch of the Night',
    cohort: 'removed',
    rank: 115,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ae018a72-882c-445d-932a-831ce2738f01_1.ogg',
    impactScore: 0.6927810112468762,
  },
  {
    id: 'a61d118f-3983-46b9-b6eb-b9c980ddaa36',
    title: 'Velocity Dreams',
    cohort: 'removed',
    rank: 116,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7832a801-c1cf-464d-a81b-6beba9c735da_1.ogg',
    impactScore: 0.6911515924585141,
  },
  {
    id: 'dcd20a02-4776-4238-b9f5-2bd6041537b3',
    title: 'Sixteen Sixteen',
    cohort: 'retained',
    rank: 117,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_58194c4e-bb32-48b0-b92c-4c1e3924ec2e_1.ogg',
    impactScore: 0.6861685485837671,
  },
  {
    id: 'ac3d8088-0b21-478d-a75a-3529f0238753',
    title: 'Bloodline Rush',
    cohort: 'removed',
    rank: 118,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_11c922b6-7ea1-4d5e-a77a-eda3da24c0c3_1.ogg',
    impactScore: 0.6857934922237169,
  },
  {
    id: '19151c8f-c4e3-441a-aa8f-6f111c1db02a',
    title: 'Afterglow Overdrive',
    cohort: 'removed',
    rank: 119,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c7fb9afb-dcb1-4b67-b8aa-9c69cb73b70e_1.ogg',
    impactScore: 0.6847062855958926,
  },
  {
    id: '3b597b63-1acc-4e17-b61f-2683452dfb3d',
    title: 'Trance/Hexd Fire',
    cohort: 'removed',
    rank: 120,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_271ac84b-dd95-4a78-94c0-cf49555e20cb_1.ogg',
    impactScore: 0.6844459400377944,
  },
  {
    id: 'c11e115a-b538-41ce-85d2-5394f81bb3cf',
    title: 'Bassline Horizon',
    cohort: 'removed',
    rank: 121,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c7443fe6-0455-4b25-8ef8-938d0fd4e4d2_0.ogg',
    impactScore: 0.6831810150193993,
  },
  {
    id: 'cbba42a3-bfd6-4d0e-bc2c-bf9358b21cce',
    title: 'Rave Collapse',
    cohort: 'removed',
    rank: 122,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2441dc38-fc08-4c7e-a659-da2c724c4584_1.ogg',
    impactScore: 0.681158217354894,
  },
  {
    id: 'b645395f-e685-4eb0-8151-5839d4edae5f',
    title: 'Berlin Static Rush',
    cohort: 'removed',
    rank: 123,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8738b50d-8ece-4253-af8f-15feed13ba59_0.ogg',
    impactScore: 0.679879111647508,
  },
  {
    id: 'bc5b5147-3a84-4182-a712-5186c0b6e5bb',
    title: 'Club Static',
    cohort: 'retained',
    rank: 124,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8474c3aa-e5e7-4991-9afa-3895b14d9eeb_0.ogg',
    impactScore: 0.6738253742670312,
  },
  {
    id: '8c544190-dfdd-4a59-b33c-998a198ca100',
    title: 'Midnight Jersey Rush',
    cohort: 'removed',
    rank: 125,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_dad704fa-bca2-419b-a8ca-7071ce65e47b_0.ogg',
    impactScore: 0.6732305669237005,
  },
  {
    id: 'a207e1d9-822f-4570-88ac-d6aee817eda8',
    title: 'Clubbed in the Static',
    cohort: 'removed',
    rank: 126,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9058d8fc-9cef-4c5f-89af-59169ddc4368_1.ogg',
    impactScore: 0.6732226852879468,
  },
  {
    id: 'e4cb23a1-3e00-4cac-9567-876a67e41b87',
    title: 'Glitch in the Rave',
    cohort: 'removed',
    rank: 127,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_bf057188-3408-44bd-8c66-69c71f569598_0.ogg',
    impactScore: 0.6723714196596403,
  },
  {
    id: '8764dc43-c5a3-45e4-8135-ef2848ae3c32',
    title: 'Club Gravity',
    cohort: 'removed',
    rank: 128,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b09d4c7f-0954-44f0-864e-18fd2535ec62_0.ogg',
    impactScore: 0.6704618842839565,
  },
  {
    id: '4ef1c735-56ae-4c4c-be62-098741b7cd2f',
    title: 'Midnight Circuit',
    cohort: 'removed',
    rank: 129,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c313677e-2a10-463a-81ef-7cb3c4b3c0f9_0.ogg',
    impactScore: 0.6691867684903432,
  },
  {
    id: '9471face-1aac-4f6d-88a6-7a8658806bb4',
    title: 'Afterglow in the Dark',
    cohort: 'removed',
    rank: 130,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_25ce63ab-b382-4457-9fe3-1fb564fd6853_1.ogg',
    impactScore: 0.6649497606796075,
  },
  {
    id: '82e291d5-3dfd-41e2-9088-173de825540f',
    title: 'Heartbeat High Voltage',
    cohort: 'removed',
    rank: 131,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_1566c765-fd76-4ddd-baed-11b15144da82_0.ogg',
    impactScore: 0.6629440382807638,
  },
  {
    id: '9f29af10-8fe5-4e7f-9014-6e9c3c834449',
    title: 'Club Horizon',
    cohort: 'retained',
    rank: 132,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f7cd6b8a-b484-449f-b6b7-2d57bd2d751e_1.ogg',
    impactScore: 0.6617439891519966,
  },
  {
    id: '2dfdcc33-c9c4-405f-b607-354a1449e156',
    title: 'Club Spectral',
    cohort: 'removed',
    rank: 133,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_43a9c282-9a0c-4fae-96be-acbf3fd63e41_1.ogg',
    impactScore: 0.6616698498665561,
  },
  {
    id: '8ed141e0-8169-438c-b173-9c368eddee2d',
    title: 'Sixteen Strings',
    cohort: 'retained',
    rank: 134,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4094b4e1-d0a8-462b-8abd-9782ea53e816_0.ogg',
    impactScore: 0.6600298176835264,
  },
  {
    id: 'd3ba468a-6165-42d7-ab29-7e3d9aa43043',
    title: 'Club Voltage',
    cohort: 'retained',
    rank: 135,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b9497bb2-8a3f-4788-9767-417dfb89800e_0.ogg',
    impactScore: 0.6600204629188486,
  },
  {
    id: 'abc8b1c9-e7a3-4e76-9ab1-e915ab5a9815',
    title: 'Club Overdrive',
    cohort: 'removed',
    rank: 136,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_1531eec9-4dab-4e8b-9581-afb7015bf1d9_1.ogg',
    impactScore: 0.659003710850911,
  },
  {
    id: '9ed53cbf-edc3-45f5-826c-2165fa593a18',
    title: 'Pulse Drift',
    cohort: 'retained',
    rank: 137,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b85cbf3b-8d71-40ab-9a37-abfeebe8b0f0_0.ogg',
    impactScore: 0.6588186449620316,
  },
  {
    id: '899b45d9-9f1b-433e-bda0-eb5546a633ea',
    title: 'High Voltage Hearts',
    cohort: 'removed',
    rank: 138,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f715c17b-f82f-4eba-a33e-3d93e8d520d6_0.ogg',
    impactScore: 0.6562400210219017,
  },
  {
    id: 'd512b8aa-c431-4a1e-9df5-07541d959490',
    title: 'Berlin Hexd',
    cohort: 'retained',
    rank: 139,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9b4c018b-46cb-47f5-af2d-66fa6cfd4506_1.ogg',
    impactScore: 0.6501066347731489,
  },
  {
    id: 'ca2449cd-a51b-40f0-8e91-6d3b4303ba49',
    title: 'Dash Through the Decks',
    cohort: 'removed',
    rank: 140,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_335d341a-e5d4-496d-acf4-f23a4fb9aeeb_1.ogg',
    impactScore: 0.649313753260664,
  },
  {
    id: '56547055-1a22-4ed0-93f9-0b6e459d2b5a',
    title: 'Sixth Gear',
    cohort: 'removed',
    rank: 141,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_70a3c88e-8bcf-4a9f-94d8-b7a108fa1c05_1.ogg',
    impactScore: 0.6453347767686747,
  },
  {
    id: 'd889da8a-1b0a-43d5-897e-df11bf6fc8f1',
    title: 'Shattered Frequencies',
    cohort: 'retained',
    rank: 142,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b9497bb2-8a3f-4788-9767-417dfb89800e_1.ogg',
    impactScore: 0.6451215253794678,
  },
  {
    id: 'ac592f96-4e1d-448c-9376-ed2d949f48ac',
    title: 'Hexline',
    cohort: 'removed',
    rank: 143,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fdfaec62-cf79-487d-8bd1-08a65dcf6b44_1.ogg',
    impactScore: 0.6429060782850715,
  },
  {
    id: 'a81a12fc-2654-4636-a1b0-e062970d33f0',
    title: 'Jersey Hex',
    cohort: 'removed',
    rank: 144,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4d4f8940-2c90-4d13-9cbc-e19850756b0a_0.ogg',
    impactScore: 0.64203317980826,
  },
  {
    id: '72b40a64-6ecd-4156-8bee-492d9adba032',
    title: 'City Pulse',
    cohort: 'retained',
    rank: 145,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2416a63f-14b3-40da-b201-cc2303ed02ff_1.ogg',
    impactScore: 0.6413036858653316,
  },
  {
    id: '204c0c45-f3ac-43ca-aa13-a891011d778e',
    title: 'Club Horizon',
    cohort: 'retained',
    rank: 146,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d8d96bf1-bb75-42b0-b664-52f9abd76e34_1.ogg',
    impactScore: 0.6390796133195055,
  },
  {
    id: 'c4f042d3-9800-43b0-9caf-5a4a4cc1a88c',
    title: 'Hexd Velocity',
    cohort: 'removed',
    rank: 147,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ef180064-9a3c-40f1-8126-8c9a1222c3f1_0.ogg',
    impactScore: 0.6366408173877709,
  },
  {
    id: 'e8bb100c-054f-45ae-94d2-d811b2553063',
    title: 'Glitch in the Jersey Sky',
    cohort: 'removed',
    rank: 148,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_97be5084-baaa-4347-90f9-3f7d32e19492_0.ogg',
    impactScore: 0.6320236518673813,
  },
  {
    id: 'c483303a-e7f9-430c-914d-3ff4327ce74e',
    title: 'Club of a Thousand Lights',
    cohort: 'removed',
    rank: 149,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6dd893a2-5fc2-4d93-9065-53d191202332_0.ogg',
    impactScore: 0.6289264414902374,
  },
  {
    id: '313821c2-9d48-4af6-b008-c6f08888333b',
    title: 'Digital Rush Hour',
    cohort: 'removed',
    rank: 150,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_88b3a212-4dce-4ab9-8ab1-a372e124d617_1.ogg',
    impactScore: 0.625556605875263,
  },
  {
    id: 'de3d71c7-99b7-4483-b3db-c0740bac7cf3',
    title: 'Club Lucid',
    cohort: 'removed',
    rank: 151,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_03458199-a0f6-4544-9f79-0dde55fcd059_0.ogg',
    impactScore: 0.6255145293423684,
  },
  {
    id: 'c881d3c7-06fb-43a4-a591-fc51b624dd4e',
    title: 'Velocity Bloom',
    cohort: 'removed',
    rank: 152,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c5dd8409-b8b5-45db-9a94-1e218c86dcb0_0.ogg',
    impactScore: 0.623696714876652,
  },
  {
    id: 'd02ee2d4-c53c-40c9-ad5e-bb98441bff86',
    title: 'Rave Velocity',
    cohort: 'removed',
    rank: 153,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3bc9a657-c08b-4cc5-a4ac-0d9dcf0ee8c3_0.ogg',
    impactScore: 0.6226575461847456,
  },
  {
    id: '9ecffb81-cfa3-4564-9e78-a3f891a38184',
    title: 'Hexd Circuit',
    cohort: 'retained',
    rank: 154,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_81002fed-aedb-4277-bbc2-18105417d0e7_0.ogg',
    impactScore: 0.6167859582521217,
  },
  {
    id: '03817515-4039-4834-899a-f27eb3e3947f',
    title: 'Hyperstate',
    cohort: 'removed',
    rank: 155,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d57153fc-7a2c-4932-a25d-7af31a05380f_0.ogg',
    impactScore: 0.6131275729818454,
  },
  {
    id: '6011caf8-ffd7-4fc8-8533-78113fa0a768',
    title: 'Velocity Bloom',
    cohort: 'retained',
    rank: 156,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6490d8c1-c7a4-481a-9c7a-10a33a81a043_1.ogg',
    impactScore: 0.6120694812867666,
  },
  {
    id: 'ac9b6419-83d6-43bd-bcb7-dc1dfec84826',
    title: 'Voltage Avenue',
    cohort: 'removed',
    rank: 157,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c94fac35-4916-4675-b6c7-61278be9a58a_1.ogg',
    impactScore: 0.6101580049765273,
  },
  {
    id: '383cb7f8-b349-4859-b9d5-90f43bd9f53a',
    title: 'Hexagonal Pulse',
    cohort: 'removed',
    rank: 158,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_01dc8246-acb6-46bc-bacf-126b99f80686_1.ogg',
    impactScore: 0.6067701043506342,
  },
  {
    id: '3389d6aa-db30-4aea-a730-55e73c5346ea',
    title: 'Club Afterglow',
    cohort: 'removed',
    rank: 159,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8e190b79-fbef-4a3f-929c-9956e62362fd_1.ogg',
    impactScore: 0.6039262302037217,
  },
  {
    id: '461a2b32-1fd9-4460-a655-0cc669a26698',
    title: 'Club Aurora',
    cohort: 'removed',
    rank: 160,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8a559aaa-f8cf-4b43-80d8-dfbec6e76f98_0.ogg',
    impactScore: 0.9627665681667191,
  },
  {
    id: '89250775-70be-4cae-9ea1-64f9bf8d419d',
    title: 'Club Static',
    cohort: 'retained',
    rank: 161,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2cde4cc5-f1b2-4a45-9085-757d40196336_1.ogg',
    impactScore: 0.5992650819569032,
  },
  {
    id: '95f6796e-da46-4b85-bb5b-01e23b313035',
    title: 'Static Euphoria',
    cohort: 'retained',
    rank: 162,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4d5e7933-9e42-4151-9af0-f0684a312cde_1.ogg',
    impactScore: 0.5985463054213209,
  },
  {
    id: '7037665a-3ae8-45b2-b9b7-baaf63bdbd97',
    title: 'Clubside Lightning',
    cohort: 'removed',
    rank: 163,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8c606045-b82e-49b9-85cb-f8130394e0e2_1.ogg',
    impactScore: 0.5981011443935003,
  },
  {
    id: 'ee352a3f-1eac-4e3a-8768-44a684c1bb15',
    title: 'Velvet Circuit',
    cohort: 'removed',
    rank: 164,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_08342246-de15-4d89-aaed-1f62e2d246fe_0.ogg',
    impactScore: 0.5950384052673217,
  },
  {
    id: '3240a56f-9dc7-4fcc-a446-c7b66eebfdb7',
    title: 'Shattered Frequency',
    cohort: 'removed',
    rank: 165,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_15b0fb23-f8af-4627-ab06-096350e63b34_0.ogg',
    impactScore: 0.590853667576657,
  },
  {
    id: '3e6e1309-4fae-4cea-8d21-7962005dd6b5',
    title: 'Strobe Paradox',
    cohort: 'removed',
    rank: 166,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7832a801-c1cf-464d-a81b-6beba9c735da_0.ogg',
    impactScore: 0.5903800460169554,
  },
  {
    id: 'd85eb211-82fd-4052-a656-fec46bd27d64',
    title: 'Shifting Frequencies',
    cohort: 'retained',
    rank: 167,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_02aba093-7f01-4ef7-83d6-7257383023cf_1.ogg',
    impactScore: 0.587654259798872,
  },
  {
    id: '4f754e70-21a7-423b-8bc3-722d33b0d6bc',
    title: 'Velocity Bloom',
    cohort: 'removed',
    rank: 168,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_80d67c0a-af84-43ee-b84a-19cd1b895c0c_0.ogg',
    impactScore: 0.5828609608993048,
  },
  {
    id: '9ae63cf7-9e11-48e6-9ff2-5d594a1f6335',
    title: 'Club Mirage',
    cohort: 'removed',
    rank: 169,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4be21b18-920b-4364-a88f-9b647792b5cc_1.ogg',
    impactScore: 0.576615301665944,
  },
  {
    id: '10b5035c-06ad-4696-b8ae-dc832ac3baf8',
    title: 'Club Static',
    cohort: 'removed',
    rank: 170,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_98521df9-99dd-4900-8c9b-5bd79dd92170_1.ogg',
    impactScore: 0.5719696131362203,
  },
  {
    id: '7bb9731e-6b10-4ea2-9d74-b29492281f5d',
    title: 'Midnight Circuit',
    cohort: 'retained',
    rank: 171,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c94fac35-4916-4675-b6c7-61278be9a58a_0.ogg',
    impactScore: 0.56250678486118,
  },
  {
    id: 'c5694f9e-b81a-4ec7-876b-b747244ca045',
    title: 'Club Voltage',
    cohort: 'removed',
    rank: 172,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9b4c018b-46cb-47f5-af2d-66fa6cfd4506_0.ogg',
    impactScore: 0.5621397693633448,
  },
  {
    id: '3c02a119-698d-426b-9805-afa28c345df5',
    title: 'Hexed Euphoria',
    cohort: 'removed',
    rank: 173,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_43cad99e-82ae-4012-8e19-cc66e5419d75_1.ogg',
    impactScore: 0.5616764999671318,
  },
  {
    id: 'b3395f2a-93f7-4c02-8498-ac4d3dd8a32b',
    title: 'Afterglow Rush',
    cohort: 'retained',
    rank: 174,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9ee44c69-e26f-46bf-9435-7216000eb274_1.ogg',
    impactScore: 0.5563283535362461,
  },
  {
    id: '597f5881-36b7-40c8-8f32-3a75343c9a5c',
    title: 'Dreamstate Drive',
    cohort: 'removed',
    rank: 175,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a5548bbc-46b0-41ce-99df-76c49bc270fd_0.ogg',
    impactScore: 0.5545394396556718,
  },
  {
    id: '10e6b79d-db92-41ce-9d1f-95fa276e8284',
    title: 'Jersey Skyline Rush',
    cohort: 'removed',
    rank: 176,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b90320f8-6dcb-4bd8-b71f-32d8b1d88fdd_1.ogg',
    impactScore: 0.5481366735751315,
  },
  {
    id: '98a2d232-1596-40e3-9bd3-2974ac917ae4',
    title: 'Hexdrive',
    cohort: 'removed',
    rank: 177,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8a438516-3f3b-4298-84ca-ccda5bd055cf_1.ogg',
    impactScore: 0.5438094973783901,
  },
  {
    id: '73eb81ce-96bd-42c6-bd44-c3417aa8775c',
    title: 'Hexed Frequencies',
    cohort: 'retained',
    rank: 178,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2ea10506-641c-4c59-b72a-5ee8f8bba06d_0.ogg',
    impactScore: 0.5349553961008642,
  },
  {
    id: '503a8e70-c66d-479d-8e98-1541490d0a90',
    title: 'Glitch in the Atmosphere',
    cohort: 'removed',
    rank: 179,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4e61a077-3ed1-4a88-a8b1-d79fe98f2a61_1.ogg',
    impactScore: 0.5310276221978922,
  },
  {
    id: 'ca0825a4-a8a2-4866-bd12-059e1b4cdef8',
    title: 'Hexed Frequency',
    cohort: 'removed',
    rank: 180,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7116cb47-e126-4fac-9fdd-f7f5cd371881_0.ogg',
    impactScore: 0.5308517444949348,
  },
  {
    id: '9d8563d8-c1b6-48cc-a15f-523285181c4f',
    title: 'Pulse of the Night',
    cohort: 'retained',
    rank: 181,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a58df7b9-1d9d-4d59-94aa-d148c3334154_1.ogg',
    impactScore: 0.530558681360041,
  },
  {
    id: '3e64d649-377e-4b9f-9d63-de06773064dc',
    title: 'Club Voltage',
    cohort: 'removed',
    rank: 182,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9ee44c69-e26f-46bf-9435-7216000eb274_0.ogg',
    impactScore: 0.5293109774958357,
  },
  {
    id: '95ab0a82-49a8-41ff-ac4c-8831e6d4bbb1',
    title: 'Infrared Heartbreak',
    cohort: 'removed',
    rank: 183,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_dc7d7373-c985-4328-ac07-42674ecb3b87_1.ogg',
    impactScore: 0.5268142781107007,
  },
  {
    id: '29404a6b-233e-49a6-9b86-d7017d797b26',
    title: 'Rush The Jersey',
    cohort: 'removed',
    rank: 184,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_666327c0-9fa3-4527-b8b6-755c3ecd8d62_0.ogg',
    impactScore: 0.5202679959483806,
  },
  {
    id: '868cfd26-67d1-4ce8-a295-ff7bab43f21c',
    title: 'Electric Hex',
    cohort: 'retained',
    rank: 185,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f4428e45-f13d-4735-a419-7fe64984a270_1.ogg',
    impactScore: 0.5198194606521379,
  },
  {
    id: 'fc243741-42c3-4c30-add5-fe685b1615cd',
    title: 'Club Collapse',
    cohort: 'removed',
    rank: 186,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_56c40c46-2ff8-4ccb-9d23-dafe3f6bd5f0_1.ogg',
    impactScore: 0.5186741845438962,
  },
  {
    id: '8e50ae61-71ad-44b5-bf4b-830d2861b684',
    title: 'Berlin Static',
    cohort: 'removed',
    rank: 187,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3d800204-2e3d-4faf-8e99-461f955bc086_1.ogg',
    impactScore: 0.5169233948441908,
  },
  {
    id: 'fec4bb8d-742c-4f37-b8d9-e5ea5e84c04b',
    title: 'Cloud Surfer',
    cohort: 'removed',
    rank: 188,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ae46d949-a2f0-4636-9a4b-fe9d19e47a72_0.ogg',
    impactScore: 0.5153489413372488,
  },
  {
    id: '84432060-4eb9-4c82-82ab-a81c2167bb9a',
    title: 'Club Frequency',
    cohort: 'removed',
    rank: 189,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_58194c4e-bb32-48b0-b92c-4c1e3924ec2e_0.ogg',
    impactScore: 0.5065132853593323,
  },
  {
    id: 'fd0d155c-d946-4543-b798-9335736bba89',
    title: 'Hexagon Heartbeat',
    cohort: 'removed',
    rank: 190,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_425af751-9f07-40ea-a26d-b5339f593e76_0.ogg',
    impactScore: 0.4991503291727065,
  },
  {
    id: 'a449f420-728c-44a5-90b5-e1d634baf738',
    title: 'Berlin Tripwires',
    cohort: 'retained',
    rank: 191,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_59292525-4c10-46fa-a649-95ccfa8f1b38_1.ogg',
    impactScore: 0.49912575940258086,
  },
  {
    id: 'dcd5053d-8d39-4b56-8e01-0d93efcce119',
    title: 'Hexed Heartbeat',
    cohort: 'removed',
    rank: 192,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8c606045-b82e-49b9-85cb-f8130394e0e2_0.ogg',
    impactScore: 0.498124898258822,
  },
  {
    id: 'cf0d1805-b52a-4508-931d-af2effc0f8d6',
    title: 'Shattered Frequency',
    cohort: 'removed',
    rank: 193,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6e677df0-003b-4139-8e48-c90166970e8d_0.ogg',
    impactScore: 0.49479070365795313,
  },
  {
    id: 'b677aa70-dca6-44b1-97bd-f0cd17467da0',
    title: 'Hexed Velocity',
    cohort: 'removed',
    rank: 194,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_16e94d0d-4d1f-48de-baab-aa43bb6ce7bc_0.ogg',
    impactScore: 0.494604404825338,
  },
  {
    id: 'bf4a3ff6-b580-4c79-9d1e-08d3093396c9',
    title: 'Glitch in the Nightline',
    cohort: 'removed',
    rank: 195,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5b349704-1bb2-4d1f-8af7-48263ba2108a_1.ogg',
    impactScore: 0.4925216134655697,
  },
  {
    id: 'b35ad5e2-53b9-4eb2-b98f-9b5fefb4dbc5',
    title: 'Club Hexed',
    cohort: 'removed',
    rank: 196,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_59292525-4c10-46fa-a649-95ccfa8f1b38_0.ogg',
    impactScore: 0.49100181439337137,
  },
  {
    id: '94dc5a19-5838-4809-a5a2-2f2340c7458c',
    title: 'Hexed Frequencies',
    cohort: 'removed',
    rank: 197,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3f052c5b-637b-490c-a69b-432d128eb6da_1.ogg',
    impactScore: 0.48844762635009864,
  },
  {
    id: '0033b426-e353-486e-a759-e4498182f065',
    title: 'Hexed Horizon',
    cohort: 'removed',
    rank: 198,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2cde4cc5-f1b2-4a45-9085-757d40196336_0.ogg',
    impactScore: 0.4873061144176572,
  },
  {
    id: '9bf12a5e-ebe1-41d7-b113-5c6d123e1101',
    title: 'Warehouse Hearts',
    cohort: 'removed',
    rank: 199,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2af6a8ed-ebdb-46b4-9364-a9ca6e788b95_1.ogg',
    impactScore: 0.4865153633970108,
  },
  {
    id: '9bbfdc51-4b89-4bbe-b6d6-91f4a6caab1f',
    title: 'Voltage Overdrive',
    cohort: 'removed',
    rank: 200,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_07bd0478-3e04-4a09-87e5-9b6ca497aed2_1.ogg',
    impactScore: 0.48563182932145815,
  },
  {
    id: '2ffa89e6-fe40-498f-ad26-19356dcc5c78',
    title: 'Midnight Voltage Rush',
    cohort: 'removed',
    rank: 201,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_99ac7d18-1e06-414f-bcd0-c1ef468ca7fb_1.ogg',
    impactScore: 0.4839051112896633,
  },
  {
    id: 'e12c420b-bd1a-413d-8a88-dc10d31bc92e',
    title: 'Club Skyline',
    cohort: 'retained',
    rank: 202,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_80d67c0a-af84-43ee-b84a-19cd1b895c0c_1.ogg',
    impactScore: 0.4831614946673024,
  },
  {
    id: '2cc7a80e-a8ce-492b-86d0-fd96f7f9470e',
    title: 'Club Hex',
    cohort: 'removed',
    rank: 203,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f38c6a5d-64ee-4f76-b14f-a702d717df83_0.ogg',
    impactScore: 0.4826710795652719,
  },
  {
    id: '919348e0-ab7a-467c-bf03-8e656c3f6ac1',
    title: 'Midnight Hex Drive',
    cohort: 'removed',
    rank: 204,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e70c64f4-c93d-4596-bcf7-a03a235f4853_0.ogg',
    impactScore: 0.4825002713038051,
  },
  {
    id: '9641a2f0-0589-4cfa-af0a-d6dd4047654a',
    title: "Club's Last Light",
    cohort: 'retained',
    rank: 205,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c5dd8409-b8b5-45db-9a94-1e218c86dcb0_1.ogg',
    impactScore: 0.48017904805624123,
  },
  {
    id: 'dd8b0c5e-fc82-46d3-a45c-215284565ee2',
    title: 'Hexed Velocity',
    cohort: 'removed',
    rank: 206,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3d800204-2e3d-4faf-8e99-461f955bc086_0.ogg',
    impactScore: 0.47976554092325735,
  },
  {
    id: 'a8f144d1-22d9-47b9-845f-27d02989b646',
    title: 'Heartbeat in Jersey',
    cohort: 'retained',
    rank: 207,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_53cca3ca-6ad9-479a-b141-d19361b2fbf4_1.ogg',
    impactScore: 0.47971770017287124,
  },
  {
    id: '10366ab6-280e-4b11-a54d-5e1c24830600',
    title: 'Hexed in the Jersey Club',
    cohort: 'retained',
    rank: 208,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_07bd0478-3e04-4a09-87e5-9b6ca497aed2_0.ogg',
    impactScore: 0.47952398367089766,
  },
  {
    id: 'a56ed532-db44-4dae-a7a5-d7972074f78a',
    title: 'Club Static',
    cohort: 'retained',
    rank: 209,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_534e4338-e503-4615-bb84-4efffe8013a4_0.ogg',
    impactScore: 0.47893105798357144,
  },
  {
    id: '455a238a-7e81-42f4-b48c-147949af664a',
    title: 'Club Overdrive',
    cohort: 'removed',
    rank: 210,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c33f8183-3a1e-4529-893e-d89a82344293_0.ogg',
    impactScore: 0.4700522777598851,
  },
  {
    id: '9db42563-e1d4-4800-a05a-957cf814efb8',
    title: 'Hexed Frequency',
    cohort: 'retained',
    rank: 211,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b90320f8-6dcb-4bd8-b71f-32d8b1d88fdd_0.ogg',
    impactScore: 0.4682744580251318,
  },
  {
    id: '006ec5ce-ff25-4339-b418-1bdf3405e40a',
    title: 'Neon Velocity',
    cohort: 'removed',
    rank: 212,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_be00e43e-20cc-41e0-8b2e-310885cc818b_0.ogg',
    impactScore: 0.4678327838488465,
  },
  {
    id: '08d8aac3-8db8-4447-96ae-dfacea6e35a8',
    title: 'Hexed Afterglow',
    cohort: 'removed',
    rank: 213,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d5752670-3650-442c-aae7-19a30c7db641_1.ogg',
    impactScore: 0.4653168518388588,
  },
  {
    id: 'fae05276-6848-4e39-b62b-987169e5af97',
    title: 'Club Static',
    cohort: 'retained',
    rank: 214,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0f7321f8-73d2-4dbc-b630-5f1dba7ba690_0.ogg',
    impactScore: 0.4647417711196773,
  },
  {
    id: '147c9308-0e7a-4e41-b818-0b1a5b1723b6',
    title: 'Berlin Afterglow',
    cohort: 'retained',
    rank: 215,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f1555a2b-b086-40d4-88f5-ad36b87029bc_1.ogg',
    impactScore: 0.46212943342112067,
  },
  {
    id: '7fcb305b-03bd-48bf-8473-fcc9250ccb9e',
    title: 'Club Synthesis',
    cohort: 'removed',
    rank: 216,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_dc00dc64-65c2-467a-aa62-38030ce8e787_1.ogg',
    impactScore: 0.46198847279110344,
  },
  {
    id: '40f7c6d0-372d-4e58-8b64-0d38a4598b20',
    title: 'Dash Through the Grid',
    cohort: 'retained',
    rank: 217,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_83ae7920-8362-48c9-a3d2-f5607690e18c_1.ogg',
    impactScore: 0.4614855798097985,
  },
  {
    id: '5b875fb1-bfa5-4083-b3cf-7e43f92dde9b',
    title: 'Sixth Gear Hearts',
    cohort: 'removed',
    rank: 218,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_88b3a212-4dce-4ab9-8ab1-a372e124d617_0.ogg',
    impactScore: 0.4556547373681347,
  },
  {
    id: '4da085cf-f4ca-4972-8d38-e7b061f87140',
    title: 'Glitch Temple',
    cohort: 'removed',
    rank: 219,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f402d064-16b0-4a11-b613-94052fcef533_0.ogg',
    impactScore: 0.44703362302831356,
  },
  {
    id: 'f3f491d9-cef4-4411-8749-352dee2aa0dc',
    title: 'Hex Highway',
    cohort: 'removed',
    rank: 220,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3fabe0c3-7a94-4ffd-ad5f-f182ce3dc9d7_0.ogg',
    impactScore: 0.4437116794455572,
  },
  {
    id: 'abc58bf9-96a7-4ce4-a39e-44ea163580ab',
    title: 'Six-String Static',
    cohort: 'removed',
    rank: 221,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8b319517-b84f-4c5d-85ac-05ca2b1b0238_1.ogg',
    impactScore: 0.44174505714091994,
  },
  {
    id: 'b9a3addb-a5e4-4b5d-9c15-950261e1deb5',
    title: 'Midnight Circuit',
    cohort: 'removed',
    rank: 222,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4ef61b9c-0fbf-4de2-820c-460d52194601_0.ogg',
    impactScore: 0.43632576326661443,
  },
  {
    id: '0608852c-e77d-4314-8756-f6988c16d86c',
    title: 'Fractured Pulse',
    cohort: 'removed',
    rank: 223,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ff78bada-0ff4-4b4a-bd98-c330a78fa16d_0.ogg',
    impactScore: 0.4355955190681773,
  },
  {
    id: 'e2db8d6a-bd8f-4e7f-9660-b1e45e10ab48',
    title: 'Velocity Hearts',
    cohort: 'removed',
    rank: 224,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_99c28e0a-2623-4f99-bb3d-626b087af8bd_0.ogg',
    impactScore: 0.43415992291143257,
  },
  {
    id: 'f0fa0032-1f3c-416b-8b85-e2da2bd8991b',
    title: 'Midnight Circuit',
    cohort: 'removed',
    rank: 225,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6f60a0c2-64e5-4da5-b769-d17b5eb807e0_1.ogg',
    impactScore: 0.4322868607450891,
  },
  {
    id: '8c210579-3e70-4d95-97c9-d9d7ea415f5c',
    title: 'Velocity Bloom',
    cohort: 'removed',
    rank: 226,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2af6a8ed-ebdb-46b4-9364-a9ca6e788b95_0.ogg',
    impactScore: 0.4232587668767547,
  },
  {
    id: 'd35f35ad-0a8f-4ad3-95ec-76be535b22e7',
    title: 'Sixth Gear Heartbeat',
    cohort: 'retained',
    rank: 227,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8a559aaa-f8cf-4b43-80d8-dfbec6e76f98_1.ogg',
    impactScore: 0.41611815162223,
  },
  {
    id: 'e7329ab7-e028-4d52-9bcf-2660f4af2872',
    title: 'Electric Velocity',
    cohort: 'removed',
    rank: 228,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_82b901ac-7e96-4072-b413-a9f805ea45c3_1.ogg',
    impactScore: 0.4141657320244321,
  },
  {
    id: '59ca8415-65f3-4b9e-a35d-f855ef86f08b',
    title: 'Tidal Pulse',
    cohort: 'removed',
    rank: 229,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fdfaec62-cf79-487d-8bd1-08a65dcf6b44_0.ogg',
    impactScore: 0.41379858776329126,
  },
  {
    id: '8e05d632-d40c-4dd1-9991-2fdd948d94d8',
    title: 'Velocity of Echoes',
    cohort: 'removed',
    rank: 230,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_edb1c447-d803-4458-935f-1bec402cd4fd_1.ogg',
    impactScore: 0.41213411214488604,
  },
  {
    id: '447eb54d-767f-40ee-8e43-20bac59cb598',
    title: 'Sixteen Hertz Heartbeat',
    cohort: 'removed',
    rank: 231,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_dc00dc64-65c2-467a-aa62-38030ce8e787_0.ogg',
    impactScore: 0.4116168500335396,
  },
  {
    id: 'cf7c3b85-b1f4-49ae-94e2-05a5ec2bb778',
    title: 'Pixel Hearts',
    cohort: 'removed',
    rank: 232,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_855030c1-3a9c-4d2a-ab9a-c93b0fa1b241_1.ogg',
    impactScore: 0.4106335704099724,
  },
  {
    id: '8781d9b3-367b-4f33-b81b-8d6ea048d2a7',
    title: 'Velocity of the Hex',
    cohort: 'retained',
    rank: 233,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9058d8fc-9cef-4c5f-89af-59169ddc4368_0.ogg',
    impactScore: 0.41034445934808994,
  },
  {
    id: '140b4f03-14b8-4bf2-b357-16b7a601dd50',
    title: 'Club Static',
    cohort: 'retained',
    rank: 234,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8b478791-65da-48a3-9a6c-f60fb0214290_0.ogg',
    impactScore: 0.4101230192333105,
  },
  {
    id: '5d32cf8b-198b-4301-b5b5-897962d51bd3',
    title: 'Jersey Dreams',
    cohort: 'removed',
    rank: 235,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3772eccf-3500-4c6a-ab2c-e1bfb30ffb3a_1.ogg',
    impactScore: 0.4088548565488569,
  },
  {
    id: '32fb4693-198e-4309-b094-fa10e644007f',
    title: 'Ultra Drive State',
    cohort: 'removed',
    rank: 236,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b81f985a-a33a-4ba2-b25d-8cdcafa46a76_0.ogg',
    impactScore: 0.4066636427493769,
  },
  {
    id: '406a6aac-a77c-4287-898c-bb0d2a8d80c8',
    title: 'Hexed Pulse',
    cohort: 'removed',
    rank: 237,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_03458199-a0f6-4544-9f79-0dde55fcd059_1.ogg',
    impactScore: 0.40533838427028973,
  },
  {
    id: '61de6b9f-93ba-40e8-9dbb-4293ad7441ae',
    title: 'Jersey Nights, Berlin Lights',
    cohort: 'removed',
    rank: 238,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a870ea9d-ca8e-447f-b651-e690f737e3d2_1.ogg',
    impactScore: 0.402367037139267,
  },
  {
    id: '698c7f38-7b72-4bfd-81fc-8656cc8405e3',
    title: 'Static Hearts Collide',
    cohort: 'removed',
    rank: 239,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9b254f2e-6cef-4338-8e48-0faaa664d85f_1.ogg',
    impactScore: 0.40175389571051845,
  },
  {
    id: '0c255ef1-098b-42b3-8360-45e74d77f986',
    title: 'High-Voltage Dreams',
    cohort: 'retained',
    rank: 240,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a5b3a3f0-e03e-48e8-90c9-381eb9efc740_0.ogg',
    impactScore: 0.400510411695523,
  },
  {
    id: '849a9384-112e-4b35-aa34-768f85a87817',
    title: 'Velocity Dreams',
    cohort: 'retained',
    rank: 241,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d3880e47-d0b9-47ab-bd80-29913d6bc13f_1.ogg',
    impactScore: 0.40002424545431786,
  },
  {
    id: 'f74997a2-e367-4644-89b3-d692e075c9fe',
    title: 'Pulse Drive',
    cohort: 'removed',
    rank: 242,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_08342246-de15-4d89-aaed-1f62e2d246fe_1.ogg',
    impactScore: 0.3995273404302592,
  },
  {
    id: 'c588cdf3-89cd-4e6e-969e-c3a7d0e56810',
    title: 'Hexed Pulse Drive',
    cohort: 'removed',
    rank: 243,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a2bad0f9-8224-4ddd-9d9f-b7c9726da4b0_0.ogg',
    impactScore: 0.3975413666811335,
  },
  {
    id: '57c850b4-a63e-402c-a35c-98dd1953d1df',
    title: 'Skyline Collapse',
    cohort: 'removed',
    rank: 244,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_855030c1-3a9c-4d2a-ab9a-c93b0fa1b241_0.ogg',
    impactScore: 0.39608997253537487,
  },
  {
    id: 'ca2b1639-64f2-453f-8b7b-33f411fb52d2',
    title: 'Velocity Nights',
    cohort: 'retained',
    rank: 245,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7bd11f25-69aa-4b99-8d70-abdd9240f43d_1.ogg',
    impactScore: 0.39570807622788157,
  },
  {
    id: '10f3df2e-8ef6-4e86-9175-9712884c1a71',
    title: 'Hexed Frequency',
    cohort: 'retained',
    rank: 246,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ac37041b-4078-4fa0-9859-7b042d966466_0.ogg',
    impactScore: 0.3940969492277077,
  },
  {
    id: '74aba64c-4a97-43b2-8976-537a6778ac72',
    title: 'Neon Rain Rush',
    cohort: 'removed',
    rank: 247,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ed3f4f05-8439-4613-825f-1655f3dde628_0.ogg',
    impactScore: 0.38511108625433055,
  },
  {
    id: '84f4161a-16a0-4c2f-ace3-7425eb5ec53e',
    title: 'Jersey Lights',
    cohort: 'removed',
    rank: 248,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_24f2a50a-40e6-4be6-aef2-a416a23adad9_0.ogg',
    impactScore: 0.38508756964737767,
  },
  {
    id: 'c25ad9c0-f23a-42bd-83ff-8a822e93d8b4',
    title: 'Velocity of Us',
    cohort: 'removed',
    rank: 249,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5b349704-1bb2-4d1f-8af7-48263ba2108a_0.ogg',
    impactScore: 0.38434532188174414,
  },
  {
    id: '00518213-120d-4aae-bc92-1353156c7d67',
    title: 'Rave Static',
    cohort: 'removed',
    rank: 250,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_20f0b579-b0df-4ad8-b63e-a1dc57c88c1a_1.ogg',
    impactScore: 0.37851148716912586,
  },
  {
    id: '53f82710-8404-4c9e-9215-247d4366cfea',
    title: 'Neon Thrust Collision',
    cohort: 'retained',
    rank: 251,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ac5702a0-e023-424f-8344-af26a2b581ae_0.ogg',
    impactScore: 0.3777449948043068,
  },
  {
    id: '163c4ec6-1e78-4bf4-ae85-f4d19d00cc97',
    title: 'Midnight Circuit',
    cohort: 'removed',
    rank: 252,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d002119d-e33b-4dab-95e2-6f45326782af_0.ogg',
    impactScore: 0.37193949704818735,
  },
  {
    id: '880352d8-a757-4a8c-b521-75826ad19b34',
    title: 'Neon Drop Zone',
    cohort: 'retained',
    rank: 253,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_12c57656-1182-41f5-a16f-f607895964e1_0.ogg',
    impactScore: 0.3674824037953983,
  },
  {
    id: '510c9884-d1d9-4b7a-bc34-5499ea58c45e',
    title: 'Hyperdrive Hearts',
    cohort: 'removed',
    rank: 254,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b2e30690-cdbf-4a27-bff5-39c2d478d278_1.ogg',
    impactScore: 0.36450051675492967,
  },
  {
    id: 'f7f2e143-4ff5-413e-ad2a-1fe178c13a4a',
    title: 'Electric Escape',
    cohort: 'removed',
    rank: 255,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_16e94d0d-4d1f-48de-baab-aa43bb6ce7bc_1.ogg',
    impactScore: 0.36202124243314154,
  },
  {
    id: 'ddca62a8-c6f0-45f4-b864-1d749e865e51',
    title: 'Electric Gravity',
    cohort: 'removed',
    rank: 256,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_026d7094-9198-4701-bdf1-943b80f62265_1.ogg',
    impactScore: 0.35843610421401684,
  },
  {
    id: '3dcfced1-1c3b-4604-9e51-7beaa828bc43',
    title: 'Glitch in the Skyline',
    cohort: 'retained',
    rank: 257,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3fabe0c3-7a94-4ffd-ad5f-f182ce3dc9d7_1.ogg',
    impactScore: 0.35560059045947745,
  },
  {
    id: '0d40161a-2496-4e98-b2f0-37cc74caca91',
    title: 'Jersey Skyline',
    cohort: 'removed',
    rank: 258,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a2bad0f9-8224-4ddd-9d9f-b7c9726da4b0_1.ogg',
    impactScore: 0.35232179211714193,
  },
  {
    id: '2bb75fd6-961d-4669-a898-ffcc07d6c348',
    title: 'Hexed Velocity',
    cohort: 'removed',
    rank: 259,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2416a63f-14b3-40da-b201-cc2303ed02ff_0.ogg',
    impactScore: 0.3457634851440861,
  },
  {
    id: '2dc17ab3-2542-41e6-a04a-81ef32dc52df',
    title: 'Jersey Shockwave',
    cohort: 'removed',
    rank: 260,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0db2cf0b-949c-4495-b22b-92a255f8884c_1.ogg',
    impactScore: 0.3438190006193984,
  },
  {
    id: '5105eb27-0c1b-4a73-9170-b428cc750ac1',
    title: 'Hexed in the City Lights',
    cohort: 'retained',
    rank: 261,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_23226efa-06aa-4f19-8874-50aedaf34b8b_0.ogg',
    impactScore: 0.3421754825079929,
  },
  {
    id: 'ad5bd840-a209-4a1e-b7f9-ce9f83dee7a7',
    title: 'Hexed Hearts',
    cohort: 'retained',
    rank: 262,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_73ff5d11-dee0-4aa7-a2e1-7abd3c46ce21_0.ogg',
    impactScore: 0.337688310624819,
  },
  {
    id: 'bae68941-368f-4dd7-9730-c0cd387586e5',
    title: 'Pulse Hexed',
    cohort: 'removed',
    rank: 263,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_816f2f81-86bf-416d-a62a-a0dbbae3b586_0.ogg',
    impactScore: 0.3365214659338874,
  },
  {
    id: '45532a9a-74f3-4b9a-8c7c-24bef9ae2fbe',
    title: 'Neon Rush Protocol',
    cohort: 'removed',
    rank: 264,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d5752670-3650-442c-aae7-19a30c7db641_0.ogg',
    impactScore: 0.3354434506117948,
  },
  {
    id: 'd88a7052-b179-4f6b-9bb7-127f38fee568',
    title: 'Midnight Circuit',
    cohort: 'removed',
    rank: 265,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f38c6a5d-64ee-4f76-b14f-a702d717df83_1.ogg',
    impactScore: 0.33108433425976413,
  },
  {
    id: '207d71dc-c08b-4d85-8d85-6c3ea6a52285',
    title: 'Velocity Decay',
    cohort: 'retained',
    rank: 266,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6f60a0c2-64e5-4da5-b769-d17b5eb807e0_0.ogg',
    impactScore: 0.33104488513406144,
  },
  {
    id: 'e5dcbc25-8f34-450a-a75a-6b3ea6ffe4b9',
    title: 'Midnight Circuit',
    cohort: 'removed',
    rank: 267,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d02e9a42-2156-4fac-a2b9-518b3e6a0836_0.ogg',
    impactScore: 0.32527517726459015,
  },
  {
    id: '2866982f-d048-406b-9756-00bfd2c94d25',
    title: 'Crimson Circuit',
    cohort: 'removed',
    rank: 268,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fc604473-c630-44ab-86c9-02f10a4881d3_0.ogg',
    impactScore: 0.3243513810748283,
  },
  {
    id: '6a6baf2e-1b75-467f-affe-2917a22042d1',
    title: 'Hexed Frequencies',
    cohort: 'retained',
    rank: 269,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3b30128d-e41e-45e9-a3cf-cc288492e1fe_0.ogg',
    impactScore: 0.32296500282970964,
  },
  {
    id: '9177a1ba-394f-4d6e-8410-bd0804ca4435',
    title: 'Hexed Frequencies',
    cohort: 'removed',
    rank: 270,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7c8764db-2bc9-4199-b7a1-0262f251d3c5_0.ogg',
    impactScore: 0.3229156398970325,
  },
  {
    id: '04e66aaa-a1d6-4770-8b68-7bc06e4c24ea',
    title: 'Pulse Off the Grid',
    cohort: 'removed',
    rank: 271,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d57153fc-7a2c-4932-a25d-7af31a05380f_1.ogg',
    impactScore: 0.3222989843558531,
  },
  {
    id: 'e7ddac6c-67bd-443d-a46b-a35335856997',
    title: 'Pulse Overdrive',
    cohort: 'removed',
    rank: 272,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d3880e47-d0b9-47ab-bd80-29913d6bc13f_0.ogg',
    impactScore: 0.31738453212493095,
  },
  {
    id: '228efb88-34b4-4943-8890-175771d51735',
    title: 'Pulse Overdrive',
    cohort: 'removed',
    rank: 273,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8b28effd-6d47-4595-a3af-7ee1f51b0a8a_1.ogg',
    impactScore: 0.31736588117829423,
  },
  {
    id: 'b0751da2-a568-4cff-a3e3-384375d62b9a',
    title: 'Midnight Circuit',
    cohort: 'removed',
    rank: 274,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e491dd4d-6a2f-47ba-98b1-a19d8979e6fe_1.ogg',
    impactScore: 0.31715826102209116,
  },
  {
    id: '87f10dcf-06e9-401d-9b6f-12d48f2381b6',
    title: 'Six Sided Rush',
    cohort: 'removed',
    rank: 275,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9405f5fb-e2cb-4473-892c-848dc0cd054b_1.ogg',
    impactScore: 0.3094898768258407,
  },
  {
    id: '03a699c1-f396-4bbd-860b-1aefdd54fe8e',
    title: 'Hexed in Motion',
    cohort: 'retained',
    rank: 276,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4e6b8a5e-0962-4ad6-8991-7ef469d6bdda_1.ogg',
    impactScore: 0.3094717799513606,
  },
  {
    id: '1d437143-ee18-4d45-b91f-04dfa736cf6f',
    title: 'Hexed Velocity',
    cohort: 'removed',
    rank: 277,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b85cbf3b-8d71-40ab-9a37-abfeebe8b0f0_1.ogg',
    impactScore: 0.3080588264196718,
  },
  {
    id: '64acf41e-6ac8-4c86-837a-4571e6915fac',
    title: 'Velocity Dreams',
    cohort: 'removed',
    rank: 278,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f872d92f-8f70-4711-80db-3f19a70ad43e_0.ogg',
    impactScore: 0.30778216253512064,
  },
  {
    id: '02ded0af-e651-4697-a1b3-2b81314171c9',
    title: 'Hex for the Taking',
    cohort: 'removed',
    rank: 279,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_629126b2-6f1d-4193-ac10-d4da3b2c8d01_0.ogg',
    impactScore: 0.30593488698050203,
  },
  {
    id: '086fd028-242e-4ca2-8172-625b1e31892e',
    title: 'Glitch Heart Ready',
    cohort: 'removed',
    rank: 280,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9405f5fb-e2cb-4473-892c-848dc0cd054b_0.ogg',
    impactScore: 0.30455788256101546,
  },
  {
    id: '1fa56aee-a7a9-444b-bd7b-9dcf6d155fb9',
    title: 'Nightshift Velocity',
    cohort: 'retained',
    rank: 281,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ca1b4505-0dfc-4229-9f5a-b3b61510a722_1.ogg',
    impactScore: 0.30400883422023783,
  },
  {
    id: '917f8200-70c4-4b5f-83c9-5fd6a1db924d',
    title: 'Glitch in My Pulse',
    cohort: 'removed',
    rank: 282,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3772eccf-3500-4c6a-ab2c-e1bfb30ffb3a_0.ogg',
    impactScore: 0.3031248564770105,
  },
  {
    id: '04670440-4c99-4d37-9e5d-5e2d7c3fdad7',
    title: 'Hexed Frequency',
    cohort: 'removed',
    rank: 283,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_88062bf0-ac4e-436c-9c6c-656854498b8a_0.ogg',
    impactScore: 0.3014585981685747,
  },
  {
    id: '40b44f33-4aa9-49bd-b6ec-919f723679bf',
    title: 'Overdrive Hearts',
    cohort: 'retained',
    rank: 284,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a5548bbc-46b0-41ce-99df-76c49bc270fd_1.ogg',
    impactScore: 0.29937876180684375,
  },
  {
    id: '4db191c9-36d4-4b35-aea5-71eaa14c4097',
    title: 'Club Overdrive',
    cohort: 'retained',
    rank: 285,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_91b68ce5-21df-4ab0-872a-d913d85d9b11_0.ogg',
    impactScore: 0.298814896227045,
  },
  {
    id: 'fd656a68-a89f-46b1-9530-c300c37d2fc4',
    title: 'Velocity Lines',
    cohort: 'retained',
    rank: 286,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_73ff5d11-dee0-4aa7-a2e1-7abd3c46ce21_1.ogg',
    impactScore: 0.2894243447477703,
  },
  {
    id: 'b75ae122-a438-43de-9a22-f178109cc597',
    title: 'Hexed Pulse',
    cohort: 'removed',
    rank: 287,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_96a59a27-9a21-42de-81eb-2696cdc40a3a_0.ogg',
    impactScore: 0.28900651306273156,
  },
  {
    id: '8471573a-c0ad-443a-ba23-fc78a8fc83e2',
    title: 'Hexed Hearts in Overdrive',
    cohort: 'removed',
    rank: 288,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e6ad80d5-2ade-403e-ad19-61e74f907063_0.ogg',
    impactScore: 0.2855395121788182,
  },
  {
    id: '569424d6-08a9-4e38-8b5b-f1ea41a46016',
    title: 'Club Skyline',
    cohort: 'removed',
    rank: 289,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7c8764db-2bc9-4199-b7a1-0262f251d3c5_1.ogg',
    impactScore: 0.2849212898612301,
  },
  {
    id: '09e593b9-0dac-414b-8019-a697cfad09aa',
    title: 'Sixth Gear Euphoria',
    cohort: 'removed',
    rank: 290,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b1cddc4d-4229-4f4c-8951-2ca3bccf9a48_1.ogg',
    impactScore: 0.2815427959544267,
  },
  {
    id: '48ca78fb-c8e9-4e06-ae96-0c8c8b451e1c',
    title: 'Velocity Bloom',
    cohort: 'retained',
    rank: 291,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8474c3aa-e5e7-4991-9afa-3895b14d9eeb_1.ogg',
    impactScore: 0.2811727821157071,
  },
  {
    id: '12ac240c-cfec-4a4c-9103-bf7e0ffd0262',
    title: 'Electric Current',
    cohort: 'removed',
    rank: 292,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b09d4c7f-0954-44f0-864e-18fd2535ec62_1.ogg',
    impactScore: 0.2811647329159823,
  },
  {
    id: '05ec3b31-5c49-4767-a655-0e6210ec99e7',
    title: 'Berlin Nights Drive',
    cohort: 'removed',
    rank: 293,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a68051eb-d3b7-40ce-997d-66ec6d6ad58f_0.ogg',
    impactScore: 0.27965473640027455,
  },
  {
    id: '89872a44-5b3a-4306-95a1-274c66110eea',
    title: 'Underground Pulse',
    cohort: 'removed',
    rank: 294,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_02aba093-7f01-4ef7-83d6-7257383023cf_0.ogg',
    impactScore: 0.2763083988362599,
  },
  {
    id: '0f7e14c4-988d-4758-b5e7-3052f80f6588',
    title: 'Hexed Velocity',
    cohort: 'removed',
    rank: 295,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_1531eec9-4dab-4e8b-9581-afb7015bf1d9_0.ogg',
    impactScore: 0.27495864377016976,
  },
  {
    id: 'd3f6545c-d4e6-4952-9b4b-bb412d7ae84f',
    title: 'Hexed Velocity',
    cohort: 'removed',
    rank: 296,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2441dc38-fc08-4c7e-a659-da2c724c4584_0.ogg',
    impactScore: 0.27439537486172566,
  },
  {
    id: '47312b3f-37c9-4539-b740-efaee2d84c4d',
    title: 'Hexagonal Heartbeat',
    cohort: 'removed',
    rank: 297,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8738b50d-8ece-4253-af8f-15feed13ba59_1.ogg',
    impactScore: 0.27435341716087586,
  },
  {
    id: '9e5cef5d-54a3-4c8a-9c74-1ccba60ea5cf',
    title: 'Strobe City',
    cohort: 'removed',
    rank: 298,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fc604473-c630-44ab-86c9-02f10a4881d3_1.ogg',
    impactScore: 0.2693801150781666,
  },
  {
    id: '112c756a-2fa7-433e-b1f8-8fdf3f5ac578',
    title: 'Shattered Frequency',
    cohort: 'retained',
    rank: 299,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_53cca3ca-6ad9-479a-b141-d19361b2fbf4_0.ogg',
    impactScore: 0.26669622827216405,
  },
  {
    id: '1a41f1ba-7fb3-4c19-818b-0ccd766062c4',
    title: 'Hyperdrive Heartbeat',
    cohort: 'removed',
    rank: 300,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_026d7094-9198-4701-bdf1-943b80f62265_0.ogg',
    impactScore: 0.26652823379910884,
  },
  {
    id: '81e9b265-14b6-4539-85d3-03ce3cdf1f88',
    title: 'Berlin Sirens',
    cohort: 'removed',
    rank: 301,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2ea10506-641c-4c59-b72a-5ee8f8bba06d_1.ogg',
    impactScore: 0.26650546193259905,
  },
  {
    id: 'a44741f9-19cb-465d-a4ad-6082c5932bd7',
    title: 'Hyperheart',
    cohort: 'removed',
    rank: 302,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4c95a815-8dd8-4b71-ab6d-bc6bb710942f_1.ogg',
    impactScore: 0.26341302149162554,
  },
  {
    id: '64d92e71-c2bc-48e4-900a-4a36d41ec37b',
    title: 'Afterglow Static',
    cohort: 'retained',
    rank: 303,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_43a9c282-9a0c-4fae-96be-acbf3fd63e41_0.ogg',
    impactScore: 0.2630305120047246,
  },
  {
    id: 'fe01f7c9-d9d0-45c3-875b-7264cc2670fb',
    title: 'Hexed Velocity',
    cohort: 'retained',
    rank: 304,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d8d96bf1-bb75-42b0-b664-52f9abd76e34_0.ogg',
    impactScore: 0.262853629306134,
  },
  {
    id: 'c563086b-0b27-46a2-9db4-b3c1141c8852',
    title: 'Pulse Drift',
    cohort: 'removed',
    rank: 305,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c313677e-2a10-463a-81ef-7cb3c4b3c0f9_1.ogg',
    impactScore: 0.2609078494852429,
  },
  {
    id: '4194c0f8-3547-4e15-a14c-8b0852f66e45',
    title: 'Bassline Phantom Zone',
    cohort: 'retained',
    rank: 306,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e90581a7-d174-4872-9657-d9404a90e699_1.ogg',
    impactScore: 0.26048697353200984,
  },
  {
    id: '6b10d667-069a-47c8-b46f-d7a5383209ad',
    title: 'Velocity Bloom',
    cohort: 'retained',
    rank: 307,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_534e4338-e503-4615-bb84-4efffe8013a4_1.ogg',
    impactScore: 0.25818701885530726,
  },
  {
    id: 'b0424375-c201-4159-b09e-a90ec0622958',
    title: 'Pulse Overdrive',
    cohort: 'removed',
    rank: 308,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_79cbddcb-cae9-41ec-8ed6-1ae4d6b2e6cf_0.ogg',
    impactScore: 0.2569569037776117,
  },
  {
    id: '00f51cd1-d086-45dc-b059-19e97472c108',
    title: 'Hexed Heartbeat',
    cohort: 'removed',
    rank: 309,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_35221472-8757-40ed-9307-a584fff09c91_0.ogg',
    impactScore: 0.25025660210486855,
  },
  {
    id: 'bb8cacdf-cf29-464c-afd6-d346038b454d',
    title: 'Hexed Heartbeat',
    cohort: 'retained',
    rank: 310,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_db83afc4-070b-4b97-a36e-b28122d277b9_1.ogg',
    impactScore: 0.24723131629890205,
  },
  {
    id: '9746089f-9661-429a-8915-3bfe66a08a7c',
    title: 'Hexed Heartbeat',
    cohort: 'removed',
    rank: 311,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fd2ce1fe-5c9c-48c8-b4d7-13cb3ef8fd42_0.ogg',
    impactScore: 0.24601016835173747,
  },
  {
    id: '158688cd-7e55-410d-b33f-b7af85bd2503',
    title: 'Hexed Hearts',
    cohort: 'retained',
    rank: 312,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f215dbf4-c153-46cc-8003-a5662ca43666_1.ogg',
    impactScore: 0.24369924482699978,
  },
  {
    id: '00915491-612c-4f81-a50d-b09262445b70',
    title: 'Glitch Hearts',
    cohort: 'removed',
    rank: 313,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_20f0b579-b0df-4ad8-b63e-a1dc57c88c1a_0.ogg',
    impactScore: 0.24297402959273232,
  },
  {
    id: 'bf497995-dfe6-43ef-82a5-43b61e048e70',
    title: 'Hexed Motion',
    cohort: 'retained',
    rank: 314,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d7902424-ee0b-448d-b865-18319df666de_1.ogg',
    impactScore: 0.24165432546009075,
  },
  {
    id: 'a171ee1e-f14c-4c7b-a276-b30a1c362a9d',
    title: 'Hexed Frequency',
    cohort: 'retained',
    rank: 315,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6a006a8c-50e6-4756-8b25-1c2766307401_1.ogg',
    impactScore: 0.23814596877131577,
  },
  {
    id: '27a71ce0-f00e-4071-9cb3-545d46c8555c',
    title: 'Club Surge',
    cohort: 'removed',
    rank: 316,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fd2ce1fe-5c9c-48c8-b4d7-13cb3ef8fd42_1.ogg',
    impactScore: 0.2323238019336789,
  },
  {
    id: '83e9eea3-b061-4bc5-9bf0-7fda5484d918',
    title: 'Club Static Overdrive',
    cohort: 'retained',
    rank: 317,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_425af751-9f07-40ea-a26d-b5339f593e76_1.ogg',
    impactScore: 0.2316047077752581,
  },
  {
    id: '7f4e4740-0189-4953-bc2c-41b7b6cadf96',
    title: 'Pulse Overload',
    cohort: 'removed',
    rank: 318,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d02e9a42-2156-4fac-a2b9-518b3e6a0836_1.ogg',
    impactScore: 0.23010193231560114,
  },
  {
    id: '46a7e6f3-5694-4fcf-abe6-8226e4dc309b',
    title: 'Hexd Velocity',
    cohort: 'removed',
    rank: 319,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_01a46f5f-9d9d-43c8-98c4-df03336cdac7_0.ogg',
    impactScore: 0.2292046475353588,
  },
  {
    id: 'a0fd740b-7ed0-4a4b-a695-84343ae4f15e',
    title: 'Club Static',
    cohort: 'retained',
    rank: 320,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_390bfc81-8bb5-4926-ae3b-f3afef86a201_0.ogg',
    impactScore: 0.22425636275829805,
  },
  {
    id: '6835b200-3ba1-4098-884b-bf7b422c01dd',
    title: 'Hexed Velocity',
    cohort: 'removed',
    rank: 321,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_454996f4-d809-4303-a179-54eed8564de5_0.ogg',
    impactScore: 0.22292640099180241,
  },
  {
    id: '32142a0b-2a21-4004-9c3d-37435bf29f25',
    title: 'Crystal City Hearts',
    cohort: 'removed',
    rank: 322,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4567014a-8965-4f88-bd65-c3825f256c5f_1.ogg',
    impactScore: 0.22104022468172912,
  },
  {
    id: '0c24f8b8-aa33-4ca2-b393-4a267698979b',
    title: 'Glitch River Run',
    cohort: 'removed',
    rank: 323,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3027c235-1bbe-431b-8edb-569471925923_1.ogg',
    impactScore: 0.21966861304244992,
  },
  {
    id: 'bf9599f1-111c-40b7-8a63-5dddc4c6c990',
    title: 'Club Static',
    cohort: 'removed',
    rank: 324,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_dc075ffb-1e2c-4bd1-af53-dd2e244d56ac_0.ogg',
    impactScore: 0.21730260257467815,
  },
  {
    id: 'a719fe9b-efa6-446d-b43c-8eabc580dab3',
    title: 'Hyperdrive Hearts',
    cohort: 'removed',
    rank: 325,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b2f3d3ca-4961-47be-acab-d070cd783d75_0.ogg',
    impactScore: 0.21292276309761696,
  },
  {
    id: '50875b6d-1a25-4feb-8597-c04ba9785d7c',
    title: 'Glitch in the Stride',
    cohort: 'retained',
    rank: 326,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_38d26e1c-799f-4132-a19c-cb8e2cd17bba_0.ogg',
    impactScore: 0.2102008970574643,
  },
  {
    id: 'c00478cf-973f-41fa-8326-94007f2c7ba2',
    title: 'Hexed Velocity',
    cohort: 'removed',
    rank: 327,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f7cd6b8a-b484-449f-b6b7-2d57bd2d751e_0.ogg',
    impactScore: 0.20644333834914672,
  },
  {
    id: '03957a8e-40e6-484f-a141-b24466d3174f',
    title: 'Ghost Club Rush',
    cohort: 'removed',
    rank: 328,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_816f2f81-86bf-416d-a62a-a0dbbae3b586_1.ogg',
    impactScore: 0.20305024743404426,
  },
  {
    id: 'ce57ad1b-eef8-41eb-860a-99d0ba4c6570',
    title: 'Hexed Heartbeat',
    cohort: 'retained',
    rank: 329,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a51dc0a9-0e6a-4609-9fa6-e3c6625a3bfc_0.ogg',
    impactScore: 0.1942875061858887,
  },
  {
    id: '8adb2c8e-7bf1-4eb0-945e-cfc461c034e4',
    title: 'Afterlight Rush',
    cohort: 'removed',
    rank: 330,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e7dfd75b-8e87-4282-b55d-7ad9911dd6fc_1.ogg',
    impactScore: 0.18641625210101012,
  },
  {
    id: '4ebcbec3-2772-45d1-b9a7-05099b7b420e',
    title: 'Heartbeat Overdrive',
    cohort: 'retained',
    rank: 331,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ca1b4505-0dfc-4229-9f5a-b3b61510a722_0.ogg',
    impactScore: 0.18349785174123787,
  },
  {
    id: '616ad232-2c60-4732-9d6d-25f3b67bd8d7',
    title: 'Club Ghost Protocol',
    cohort: 'retained',
    rank: 332,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6a006a8c-50e6-4756-8b25-1c2766307401_0.ogg',
    impactScore: 0.18318659033483173,
  },
  {
    id: 'e0406d02-2e94-4e45-bc8a-769ed7f65ac2',
    title: 'Velocity Static',
    cohort: 'retained',
    rank: 333,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_88062bf0-ac4e-436c-9c6c-656854498b8a_1.ogg',
    impactScore: 0.1793944214453459,
  },
  {
    id: 'e6633bc6-6c5a-442c-9819-d67d727d72c7',
    title: 'Pulse Divide',
    cohort: 'retained',
    rank: 334,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c7443fe6-0455-4b25-8ef8-938d0fd4e4d2_1.ogg',
    impactScore: 0.17828997954107814,
  },
  {
    id: '456cecff-6c38-44e7-b290-7afed2103cc2',
    title: 'Berlin Nights',
    cohort: 'retained',
    rank: 335,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f9a71830-42f2-438a-b45d-e37c6532ff20_1.ogg',
    impactScore: 0.17774298135039082,
  },
  {
    id: 'b17bd51b-5fea-490a-946e-6ff8da34fbb1',
    title: 'Hexd Dreams',
    cohort: 'retained',
    rank: 336,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_dad704fa-bca2-419b-a8ca-7071ce65e47b_1.ogg',
    impactScore: 0.17725800904907837,
  },
  {
    id: '99f4afc1-690a-4928-83be-1ba90810bac5',
    title: 'Electric Heartbeat',
    cohort: 'removed',
    rank: 337,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4e6b8a5e-0962-4ad6-8991-7ef469d6bdda_0.ogg',
    impactScore: 0.17567852902575098,
  },
  {
    id: 'd4030e27-959c-4deb-a4ec-922bd9d51c2e',
    title: 'Electric Aftermath',
    cohort: 'retained',
    rank: 338,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_666327c0-9fa3-4527-b8b6-755c3ecd8d62_1.ogg',
    impactScore: 0.17505716385271214,
  },
  {
    id: '7ea4be34-6312-4dd2-803e-f1f24fab8944',
    title: 'Hexed Frequency',
    cohort: 'retained',
    rank: 339,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_89a3f41e-78fc-4229-a757-9a7a729be61c_0.ogg',
    impactScore: 0.1745713871623404,
  },
  {
    id: 'e4492dc1-5f2b-4875-963b-a439d5a43e12',
    title: 'Pulse Overdrive',
    cohort: 'retained',
    rank: 340,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a51dc0a9-0e6a-4609-9fa6-e3c6625a3bfc_1.ogg',
    impactScore: 0.17388874551519928,
  },
  {
    id: '2614aee1-14c1-4968-a5ed-5ea62df4610f',
    title: 'Hexed Skyline',
    cohort: 'removed',
    rank: 341,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_07deeaec-7a1e-4423-94a4-effbca0e3da4_0.ogg',
    impactScore: 0.16927219217908518,
  },
  {
    id: '33370e13-306e-4e5c-aed2-18bcb475abf9',
    title: 'Club Resonance',
    cohort: 'removed',
    rank: 342,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_01a46f5f-9d9d-43c8-98c4-df03336cdac7_1.ogg',
    impactScore: 0.16421306770707997,
  },
  {
    id: 'c8fa9ab8-3304-44bc-8399-482a74a6d5f4',
    title: 'Glitch in the Crosswalk',
    cohort: 'removed',
    rank: 343,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_82b901ac-7e96-4072-b413-a9f805ea45c3_0.ogg',
    impactScore: 0.16047207270096756,
  },
  {
    id: '4b128f34-1342-4cf2-9853-5e4189f5d181',
    title: 'Hexed Hearts',
    cohort: 'removed',
    rank: 344,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0db2cf0b-949c-4495-b22b-92a255f8884c_0.ogg',
    impactScore: 0.15633471825820938,
  },
  {
    id: '5ffebacc-bcbb-4160-b0bb-08748b6849df',
    title: 'Hexed Frequency',
    cohort: 'removed',
    rank: 345,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_dc075ffb-1e2c-4bd1-af53-dd2e244d56ac_1.ogg',
    impactScore: 0.15501079354980443,
  },
  {
    id: 'aed3c22e-4ff1-4a62-9ab8-f431e254e3a7',
    title: 'Kinetic Pulse',
    cohort: 'removed',
    rank: 346,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_327a47c5-6f59-436c-92e3-74579001bd62_1.ogg',
    impactScore: 0.15376956786326326,
  },
  {
    id: '8aff0613-d6fb-4039-863d-553cd694a979',
    title: 'Dashline Breakdown',
    cohort: 'retained',
    rank: 347,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_be00e43e-20cc-41e0-8b2e-310885cc818b_1.ogg',
    impactScore: 0.15060825366687633,
  },
  {
    id: 'abe0547a-4d46-4686-aaea-716e64f35654',
    title: 'Glitch Cathedral',
    cohort: 'retained',
    rank: 348,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_56c40c46-2ff8-4ccb-9d23-dafe3f6bd5f0_0.ogg',
    impactScore: 0.14566713318013566,
  },
  {
    id: '4ffe8546-d622-4876-aedd-5e3e17e72a04',
    title: 'Glitch Parade',
    cohort: 'retained',
    rank: 349,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_51581ac2-1cca-4f9e-b7f2-c3f123df1d3b_1.ogg',
    impactScore: 0.1366866745649584,
  },
  {
    id: '8ecc9e1a-4fff-419d-aef7-f90816ef4304',
    title: 'Club Horizon',
    cohort: 'retained',
    rank: 350,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9ad06be0-b62f-443f-b6d8-1ede4aac1de3_0.ogg',
    impactScore: 0.12914204520723743,
  },
  {
    id: '311ee0ce-4b30-4e28-9285-2fb46c4a55e8',
    title: 'Neon Hex Overflow',
    cohort: 'removed',
    rank: 351,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_59302710-6b7a-41df-a713-f299f4529485_1.ogg',
    impactScore: 0.12813139234160195,
  },
  {
    id: '3842f6f6-1982-461d-85ab-556ea641232b',
    title: 'Pulse Drive',
    cohort: 'removed',
    rank: 352,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_24f2a50a-40e6-4be6-aef2-a416a23adad9_1.ogg',
    impactScore: 0.1232934148530023,
  },
  {
    id: '3973fd54-7e22-4768-8690-20810591385e',
    title: 'Clubside Mirage',
    cohort: 'removed',
    rank: 353,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ac37041b-4078-4fa0-9859-7b042d966466_1.ogg',
    impactScore: 0.12140161036497263,
  },
  {
    id: '5e682002-9dbd-4a98-9431-33ca980e0fab',
    title: 'Strobe City Fire',
    cohort: 'removed',
    rank: 354,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b9a1f683-d29a-4615-a5ec-694a0d1866cd_1.ogg',
    impactScore: 0.12001130593417147,
  },
  {
    id: 'f4177fd0-a526-4e9a-9cf6-d2258039dd18',
    title: 'Electric Fallout',
    cohort: 'removed',
    rank: 355,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_91b68ce5-21df-4ab0-872a-d913d85d9b11_1.ogg',
    impactScore: 0.11636071567981424,
  },
  {
    id: '6ef727d8-318a-411a-8cc6-36eb51333f18',
    title: 'Club Rotation Syndrome',
    cohort: 'removed',
    rank: 356,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_59302710-6b7a-41df-a713-f299f4529485_0.ogg',
    impactScore: 0.11393179915631647,
  },
  {
    id: 'ca4e5041-93a5-4aa5-85df-a8299bcf8efe',
    title: 'Hexed Frequencies',
    cohort: 'removed',
    rank: 357,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_97be5084-baaa-4347-90f9-3f7d32e19492_1.ogg',
    impactScore: 0.11357402137813477,
  },
  {
    id: '3acfaa58-40de-40ed-942d-6d32d325212b',
    title: 'Hexed Velocity',
    cohort: 'removed',
    rank: 358,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_15b0fb23-f8af-4627-ab06-096350e63b34_1.ogg',
    impactScore: 0.10789391722883139,
  },
  {
    id: 'd0d60a68-93cd-4ba1-a0f2-3ddb69bb74ac',
    title: 'Glitch in the Rave',
    cohort: 'retained',
    rank: 359,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c7fb9afb-dcb1-4b67-b8aa-9c69cb73b70e_0.ogg',
    impactScore: 0.09982816565168988,
  },
  {
    id: '3d76c9e6-1efb-4093-9ae6-5804a5ff2991',
    title: 'Bassline Overdrive',
    cohort: 'removed',
    rank: 360,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_96a59a27-9a21-42de-81eb-2696cdc40a3a_1.ogg',
    impactScore: 0.09140168618013975,
  },
  {
    id: '98e4fb96-064a-44bc-a599-20d7842a762d',
    title: 'Glitch Heart',
    cohort: 'retained',
    rank: 361,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d002119d-e33b-4dab-95e2-6f45326782af_1.ogg',
    impactScore: 0.08199122109144803,
  },
  {
    id: 'bb8d5076-ab1f-406e-b783-58bdfb9ab8d6',
    title: 'Hexed Velocity',
    cohort: 'removed',
    rank: 362,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4567014a-8965-4f88-bd65-c3825f256c5f_0.ogg',
    impactScore: 0.026886067111380158,
  },
];
